// AUTO-GENERATED — do not edit. Run scripts/gen-template-manifest.mjs to regenerate.

import thumb1 from "./template1/thumbnail.jpg";
import thumb2 from "./template2/thumbnail.jpg";
import thumb3 from "./template3/thumbnail.jpg";
import thumb4 from "./template4/thumbnail.jpg";
import thumb5 from "./template5/thumbnail.jpg";
import thumb6 from "./template6/thumbnail.jpg";
import thumb7 from "./template7/thumbnail.jpg";
import thumb8 from "./template8/thumbnail.jpg";
import thumb9 from "./template9/thumbnail.jpg";
import thumb10 from "./template10/thumbnail.jpg";
import thumb11 from "./template11/thumbnail.jpg";
import thumb12 from "./template12/thumbnail.jpg";
import thumb13 from "./template13/thumbnail.jpg";
import thumb14 from "./template14/thumbnail.jpg";
import thumb15 from "./template15/thumbnail.jpg";
import thumb16 from "./template16/thumbnail.jpg";
import thumb17 from "./template17/thumbnail.jpg";
import thumb18 from "./template18/thumbnail.jpg";
import thumb19 from "./template19/thumbnail.jpg";
import thumb20 from "./template20/thumbnail.jpg";
import thumb21 from "./template21/thumbnail.jpg";
import thumb22 from "./template22/thumbnail.jpg";
import thumb23 from "./template23/thumbnail.jpg";
import thumb24 from "./template24/thumbnail.jpg";
import thumb25 from "./template25/thumbnail.jpg";
import thumb26 from "./template26/thumbnail.jpg";
import thumb27 from "./template27/thumbnail.jpg";
import thumb28 from "./template28/thumbnail.jpg";
import thumb29 from "./template29/thumbnail.jpg";
import thumb30 from "./template30/thumbnail.jpg";
import thumb31 from "./template31/thumbnail.jpg";
import thumb32 from "./template32/thumbnail.jpg";
import thumb33 from "./template33/thumbnail.jpg";
import thumb34 from "./template34/thumbnail.jpg";
import thumb35 from "./template35/thumbnail.jpg";
import thumb36 from "./template36/thumbnail.jpg";
import thumb37 from "./template37/thumbnail.jpg";
import thumb38 from "./template38/thumbnail.jpg";
import thumb39 from "./template39/thumbnail.jpg";
import thumb40 from "./template40/thumbnail.jpg";
import thumb41 from "./template41/thumbnail.jpg";
import thumb42 from "./template42/thumbnail.jpg";
import thumb43 from "./template43/thumbnail.jpg";
import thumb44 from "./template44/thumbnail.jpg";
import thumb45 from "./template45/thumbnail.jpg";
import thumb46 from "./template46/thumbnail.jpg";
import thumb47 from "./template47/thumbnail.jpg";
import thumb48 from "./template48/thumbnail.jpg";
import thumb49 from "./template49/thumbnail.jpg";
import thumb50 from "./template50/thumbnail.jpg";

export interface MjmlStarterTemplate {
  id: string;
  title: string;
  mjml: string;
  thumbnail: string;
}

export const MJML_STARTER_TEMPLATES: MjmlStarterTemplate[] = [
  {
    id: "template1",
    title: "Best Recipes",
    thumbnail: thumb1,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Best Recipes
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Helvetica" name="Helvetica"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
      <mj-text color="#000000" font-size="16px" line-height="1.5"></mj-text>
      <mj-button background-color="#f45e43" border-radius="3px" color="white"></mj-button>
    </mj-attributes>
    <mj-style>
      .recipe-card {
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f4f4f4">
    <mj-raw>
      <!-- Header with Logo -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px 0">
      <mj-column>
        <mj-image alt="Restaurant Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Image Section -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Burger" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/lpegypjetcqboxuiwv5e7_image.png" width="600px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Intro Text -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="40px 0 20px">
      <mj-column>
        <mj-text align="center" font-size="24px" font-weight="bold">
          See some of our BEST recipes
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px" padding="20px 40px">
          This is where you can put your most important content. Tell them your best news any size or style. Maybe you need to link to something. Whether it's an important announcement, new products or services, or you're going to show about a special promotion - tell it clearly, you're excited. Make it real fun.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Recipe Cards -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column css-class="recipe-card" width="100%">
        <mj-image alt="Cocktail" height="300px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/4fgwic1y8ynasg8up4_c2_image.png" width="400px"></mj-image>
        <mj-text align="center" font-size="20px" font-weight="bold" padding-top="20px">
          Mix Your Cocktail
        </mj-text>
        <mj-text align="center" color="#666666">
          Add a line or two about what this story is about
        </mj-text>
        <mj-button href="#" padding-bottom="30px">
          Learn More
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column css-class="recipe-card" width="100%">
        <mj-image alt="Dinner" height="300px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/dqjnflporswvmpxe9jwgm_image.png" width="400px"></mj-image>
        <mj-text align="center" font-size="20px" font-weight="bold" padding-top="20px">
          Start A Dinner For 2
        </mj-text>
        <mj-text align="center" color="#666666">
          Add a line or two about what this story is about
        </mj-text>
        <mj-button href="#" padding-bottom="30px">
          Learn More
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column css-class="recipe-card" width="100%">
        <mj-image alt="Raspberry Cake" height="300px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/wq7y3quyz4kpfzmfccqcy_image.png" width="400px"></mj-image>
        <mj-text align="center" font-size="20px" font-weight="bold" padding-top="20px">
          Our Favorite Raspberry Cake
        </mj-text>
        <mj-text align="center" color="#666666">
          Add a line or two about what this story is about
        </mj-text>
        <mj-button href="#" padding-bottom="30px">
          Learn More
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Instagram Section -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="20px" font-weight="bold">
          SHARE YOUR PLATE WITH US
        </mj-text>
        <mj-social align="center" icon-size="24px" mode="horizontal">
          <mj-social-element name="twitter" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180069371_xkd0kfnytbfywsofk8t6.png"></mj-social-element>
          <mj-social-element name="facebook" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180102922_ulyduaza1votoacctoi3.png"></mj-social-element>
          <mj-social-element name="instagram" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180131603_wtefhsfwaapcdbz7knqw.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="16px" padding-top="10px">
          @LOOKATMYPLATE
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-text align="center" color="#666666" font-size="12px" padding-top="10px">
          No longer want to receive these emails? <a href="{{unsubscribeUrl}}" style="color: #666666;">Unsubscribe</a>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template2",
    title: "Cheers to summer!",
    thumbnail: thumb2,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Cheers to summer!
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Helvetica" name="Helvetica"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#fafafa">
    <mj-wrapper background-color="#ffffff">
      <mj-raw>
        <!-- Header -->
      </mj-raw>
      <mj-section padding="20px">
        <mj-column>
          <mj-image align="left" alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
        </mj-column>
        <mj-column>
          <mj-navbar>
            <mj-navbar-link color="#000" href="#">
              SHOP
            </mj-navbar-link>
            <mj-navbar-link color="#000" href="#">
              ABOUT
            </mj-navbar-link>
            <mj-navbar-link color="#000" href="#">
              CONTACT
            </mj-navbar-link>
            <mj-navbar-link color="#000" href="#">
              BLOG
            </mj-navbar-link>
          </mj-navbar>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Hero Section -->
      </mj-raw>
      <mj-section padding="0 20px">
        <mj-column>
          <mj-text align="center" color="#000000" font-size="24px">
            Cheers to summer!
          </mj-text>
          <mj-text align="center" color="#000000">
            Get ready to host your next family gathering.<br />
            Save up to 15% on EVERYTHING storewide.
          </mj-text>
          <mj-button background-color="#4A2512" color="white" href="#">
            SHOP ALL
          </mj-button>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Main Image -->
      </mj-raw>
      <mj-section padding="0 20px">
        <mj-column>
          <mj-image alt="Family Dinner" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hfbculirg8bin9ddnnawe_image.png"></mj-image>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Products Section -->
      </mj-raw>
      <mj-section padding="20px">
        <mj-column width="50%">
          <mj-text color="#000000" font-size="20px">
            Products made to last
          </mj-text>
          <mj-text color="#000000">
            We use quality, non-toxic materials for you and your family.
          </mj-text>
          <mj-button background-color="#4A2512" color="white" href="#">
            Start browsing
          </mj-button>
        </mj-column>
        <mj-column width="50%">
          <mj-image alt="Kitchen Utensils" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/19lwfnaxluotystpvnhdj_image.png"></mj-image>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Aesthetic Section -->
      </mj-raw>
      <mj-section padding="20px">
        <mj-column width="50%">
          <mj-image alt="Kitchen Items" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/oi9fic_qgych3ogiirzz7_image.png"></mj-image>
        </mj-column>
        <mj-column width="50%">
          <mj-text color="#000000" font-size="20px">
            Find your perfect aesthetic
          </mj-text>
          <mj-text color="#000000">
            Mix & match or shop our bundles.
          </mj-text>
          <mj-button background-color="#4A2512" color="white" href="#">
            Shop bundles
          </mj-button>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Footer -->
      </mj-raw>
      <mj-section background-color="#4A2512" padding="20px">
        <mj-column>
          <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
          </mj-social>
          <mj-text align="center" color="white" font-size="12px">
            No longer want to receive these emails? <a href="{{unsubscribeUrl}}" class="link-nostyle" style="color: white;">unsubscribe</a>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`,
  },
  {
    id: "template3",
    title: "Discover Our Artisanal Coffee Collection",
    thumbnail: thumb3,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Discover Our Artisanal Coffee Collection
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700" name="Playfair Display"></mj-font>
    <mj-font href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700" name="Lato"></mj-font>
    <mj-attributes>
      <mj-all font-family="Lato, Arial, sans-serif"></mj-all>
      <mj-text font-size="16px" font-weight="300" line-height="1.6"></mj-text>
      <mj-wrapper background-color="#F5F3EF" padding="0"></mj-wrapper>
    </mj-attributes>
    <mj-style>
      .playfair { font-family: 'Playfair Display', serif; }
      .link-nostyle { color: inherit; text-decoration: none; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#ffffff">
    <mj-raw>
      <!-- Main Content Wrapper -->
    </mj-raw>
    <mj-wrapper>
      <mj-raw>
        <!-- Header -->
      </mj-raw>
      <mj-section padding="20px">
        <mj-column>
          <mj-image alt="Restaurant Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
        </mj-column>
      </mj-section>
      <mj-raw>
        <!-- Hero Section -->
      </mj-raw>
      <mj-section padding="0">
        <mj-column>
          <mj-image alt="Coffee Hero" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/f2awkpbykjlgci-ksdfhh_image.png"></mj-image>
        </mj-column>
      </mj-section>
    </mj-wrapper>
    <mj-raw>
      <!-- Welcome Text -->
    </mj-raw>
    <mj-wrapper></mj-wrapper>
    <mj-raw>
      <!-- Featured Products (Light Background) -->
    </mj-raw>
    <mj-wrapper background-color="#F5F3EF">
      <mj-section padding-top="40px">
        <mj-column padding="10px" width="50%">
          <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/zogjzzskdt59aofu3yxsa_image.png"></mj-image>
          <mj-text align="center" color="#2C1810" font-family="Playfair Display" font-size="24px">
            Single Origin
          </mj-text>
          <mj-text align="center" color="#5E4D44">
            Experience the unique flavors of our single-origin beans.
          </mj-text>
          <mj-button background-color="transparent" border="1px solid #8B5E3C" color="#8B5E3C" href="#">
            SHOP NOW
          </mj-button>
        </mj-column>
        <mj-column padding="10px" width="50%">
          <mj-image alt="Brewing Equipment" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jgn4ce6kkdlybrmm-4pso_image.png"></mj-image>
          <mj-text align="center" color="#2C1810" font-family="Playfair Display" font-size="24px">
            Brewing Essentials
          </mj-text>
          <mj-text align="center" color="#5E4D44">
            Elevate your coffee ritual with our premium brewing equipment.
          </mj-text>
          <mj-button background-color="transparent" border="1px solid #8B5E3C" color="#8B5E3C" href="#">
            DISCOVER MORE
          </mj-button>
        </mj-column>
      </mj-section>
    </mj-wrapper>
    <mj-raw>
      <!-- Special Offer (Dark Background) -->
    </mj-raw>
    <mj-wrapper background-color="#2C1810">
      <mj-section padding-bottom="40px" padding-top="40px">
        <mj-column>
          <mj-text align="center" color="white" font-family="Playfair Display" font-size="28px">
            Special Offer
          </mj-text>
          <mj-text align="center" color="#E6DDD4">
            Enjoy 15% off your first order with code: FIRSTBREW
          </mj-text>
          <mj-button background-color="#E6DDD4" color="#2C1810" font-family="Lato" font-weight="700" href="#">
            CLAIM OFFER
          </mj-button>
        </mj-column>
      </mj-section>
    </mj-wrapper>
    <mj-raw>
      <!-- Instagram Feed (Light Background) -->
    </mj-raw>
    <mj-wrapper background-color="#F5F3EF">
      <mj-section padding-bottom="20px" padding-top="40px">
        <mj-column>
          <mj-text align="center" color="#2C1810" font-family="Playfair Display" font-size="24px">
            Follow Our Journey
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section padding-top="0">
        <mj-column padding="5px" width="33.33%">
          <mj-image alt="Instagram 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/f2awkpbykjlgci-ksdfhh_image.png"></mj-image>
        </mj-column>
        <mj-column padding="5px" width="33.33%">
          <mj-image alt="Instagram 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/zogjzzskdt59aofu3yxsa_image.png"></mj-image>
        </mj-column>
        <mj-column padding="5px" width="33.33%">
          <mj-image alt="Instagram 3" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jgn4ce6kkdlybrmm-4pso_image.png"></mj-image>
        </mj-column>
      </mj-section>
    </mj-wrapper>
    <mj-raw>
      <!-- Footer (Dark Background) -->
    </mj-raw>
    <mj-wrapper background-color="#2C1810">
      <mj-section padding-top="40px">
        <mj-column>
          <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
            <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
          </mj-social>
          <mj-text align="center" color="#E6DDD4" font-size="12px" padding-top="20px">
            © 2024 Artisan Coffee Co. All rights reserved.
          </mj-text>
          <mj-text align="center" color="#E6DDD4" font-size="12px">
            You're receiving this email because you subscribed to our newsletter.
            <a href="{{unsubscribeUrl}}" class="link-nostyle" style="color: #E6DDD4; text-decoration: underline;">Unsubscribe</a>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`,
  },
  {
    id: "template4",
    title: "Discover Your Next Adventure",
    thumbnail: thumb4,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Discover Your Next Adventure
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Helvetica" name="Helvetica"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#f4f4f4">
    <mj-raw>
      <!-- Header Section -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-bottom="0px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" padding="20px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column>
        <mj-image alt="Travel Hero" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591861690297_photo-1469854523086-cc02fe5d8800_w_600.png"></mj-image>
        <mj-text align="center" color="#1A1A1A" font-size="30px" padding-top="20px">
          Explore the World
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          Discover amazing destinations and unforgettable experiences
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Featured Destinations -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-top="20px">
      <mj-column width="33.33%">
        <mj-image alt="Paris" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591862769998_photo-1533105079780-92b9be482077_w_600.png" width="200px"></mj-image>
        <mj-text align="center" color="#1A1A1A" font-size="20px">
          Paris
        </mj-text>
        <mj-text align="center" color="#666666" font-size="14px" padding-left="0px" padding-right="0px">
          City of Light
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Tokyo" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591863331899_photo-1524231757912-21f4fe3a7200.png" width="200px"></mj-image>
        <mj-text align="center" color="#1A1A1A" font-size="20px">
          Tokyo
        </mj-text>
        <mj-text align="center" color="#666666" font-size="14px" padding-left="0px" padding-right="0px">
          Modern Meets Traditional
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="New York" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918645916100_photo-1518509562904-e7ef99cdcc86_w_600.png" width="200px"></mj-image>
        <mj-text align="center" color="#1A1A1A" font-size="20px">
          New York
        </mj-text>
        <mj-text align="center" color="#666666" font-size="14px" padding-left="0px" padding-right="0px">
          The City That Never Sleeps
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- CTA Section -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-button background-color="#1A1A1A" color="white" href="#">
          Book Your Trip Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element name="facebook" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element name="twitter" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element name="instagram" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Travel Company. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template5",
    title: "Culinary Delights Weekly Newsletter",
    thumbnail: thumb5,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Culinary Delights Weekly Newsletter
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Playfair+Display" name="Playfair Display"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
      <mj-text color="#333333" font-size="16px" line-height="1.5"></mj-text>
    </mj-attributes>
    <mj-style>
      .header-text { font-family: 'Playfair Display', serif; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f8f5f2">
    <mj-raw>
      <!-- Header with Logo -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" padding="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Banner -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Restaurant Interior" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918660929101_photo-1414235077428-338989a2e8c0_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Welcome Text -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-bottom="20px" padding-top="40px">
      <mj-column>
        <mj-text align="center" color="#1a1a1a" font-family="Playfair Display, serif" font-size="32px">
          Welcome to Our Culinary World
        </mj-text>
        <mj-text align="center" color="#666666">
          Experience the finest dining and seasonal specialties
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Featured Dishes - Two Columns -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column width="50%">
        <mj-image alt="Seasonal Dish" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918672007102_photo-1504674900247-0877df9cc836_w_600.png" width="300px"></mj-image>
        <mj-text align="center" font-family="Playfair Display, serif" font-size="24px">
          Seasonal Menu
        </mj-text>
        <mj-text align="center" color="#666666">
          Fresh ingredients, expertly prepared
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Special Dessert" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918679354103_photo-1551024506-0bccd828d307.png" width="300px"></mj-image>
        <mj-text align="center" font-family="Playfair Display, serif" font-size="24px">
          Signature Desserts
        </mj-text>
        <mj-text align="center" color="#666666">
          Sweet endings to perfect meals
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Special Offer -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-family="Playfair Display, serif" font-size="24px">
          Special Offer
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Enjoy 20% off your first visit this month
        </mj-text>
        <mj-button background-color="#c8a97e" border-radius="4px" color="#ffffff" href="#">
          Book a Table
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Chef's Recommendation -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column width="40%">
        <mj-image alt="Chef Special" border-radius="125px" height="250px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918691323104_photo-1600565193348-f74bd3c7ccdf.png" width="250px"></mj-image>
      </mj-column>
      <mj-column width="60%">
        <mj-text font-family="Playfair Display, serif" font-size="24px">
          Chef's Recommendation
        </mj-text>
        <mj-text color="#666666">
          "Try our new truffle-infused risotto, made with locally sourced mushrooms and aged Parmesan."
        </mj-text>
        <mj-text color="#666666" font-style="italic">
          - Executive Chef Michael
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#f8f5f2">
      <mj-column>
        <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#c8a97e" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element background-color="#c8a97e" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element background-color="#c8a97e" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          123 Gourmet Street, Culinary City | Tel: (555) 123-4567
        </mj-text>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Fine Dining Restaurant. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template6",
    title: "Gaming Weekly: Level Up Your Experience!",
    thumbnail: thumb6,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Gaming Weekly: Level Up Your Experience!
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Roboto:400,700" name="Roboto"></mj-font>
    <mj-attributes>
      <mj-all font-family="Roboto, Arial, sans-serif"></mj-all>
    </mj-attributes>
    <mj-style>
      .neon-text { text-shadow: 0 0 10px #00ff00; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#0a0a0a">
    <mj-raw>
      <!-- Header with Animated Feel -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" padding="20px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Gaming Hero" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918713027105_photo-1538481199705-c710c4e965fc.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Main Title -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding-top="30px">
      <mj-column>
        <mj-text align="center" color="#00ff00" font-size="36px" font-weight="bold">
          GAME ON!
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="18px">
          Your Weekly Gaming Universe Update
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Featured Games Grid -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding-top="20px">
      <mj-column padding="10px" width="50%">
        <mj-image alt="Game 1" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918725387106_photo-1542751371-adc38448a05e.png"></mj-image>
        <mj-text align="center" color="#00ff00" font-size="20px" padding-top="15px">
          NEW RELEASE
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Cyber Adventure 2024
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="50%">
        <mj-image alt="Game 2" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918735612107_photo-1550745165-9bc0b252726f.png"></mj-image>
        <mj-text align="center" color="#00ff00" font-size="20px" padding-top="15px">
          TRENDING NOW
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Space Warriors
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Special Offer -->
    </mj-raw>
    <mj-section background-color="#2a0a2a" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ff00ff" font-size="24px" font-weight="bold">
          🎮 SPECIAL OFFER 🎮
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Get 50% off on all premium games this weekend!
        </mj-text>
        <mj-button background-color="#ff00ff" border-radius="25px" color="#ffffff" padding="15px 30px">
          CLAIM OFFER
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Gaming News -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="News 1" height="150px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918745678108_photo-1580327332925-a10e6cb11baa.png"></mj-image>
        <mj-text align="center" color="#00ff00" font-size="16px">
          E-Sports Update
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="News 2" height="150px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918756840109_photo-1612287230202-1ff1d85d1bdf.png"></mj-image>
        <mj-text align="center" color="#00ff00" font-size="16px">
          Tech Reviews
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="News 3" height="150px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918769341110_photo-1593305841991-05c297ba4575.png"></mj-image>
        <mj-text align="center" color="#00ff00" font-size="16px">
          Game Guides
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Stream Section -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          🎥 LIVE STREAMS
        </mj-text>
        <mj-image alt="Stream" padding="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918786421111_photo-1561736778-92e52a7769ef_w_600.png"></mj-image>
        <mj-text align="center" color="#00ff00">
          Join our next live stream tomorrow at 8PM EST
        </mj-text>
        <mj-button background-color="#6441a5" border-radius="5px" color="#ffffff">
          FOLLOW CHANNEL
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Community Section -->
    </mj-raw>
    <mj-section background-color="#1a1a1a">
      <mj-column>
        <mj-text align="center" color="#00ff00" font-size="24px">
          JOIN OUR COMMUNITY
        </mj-text>
        <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#0a0a0a">
      <mj-column>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Gaming Universe. All rights reserved.
        </mj-text>
        <mj-text align="center" color="#666666" font-size="10px">
          You received this email because you subscribed to our gaming newsletter.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template7",
    title: "Tech Weekly Update",
    thumbnail: thumb7,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Tech Weekly Update
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600" name="Inter"></mj-font>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#0A0A0A">
    <mj-raw>
      <!-- Minimal Header -->
    </mj-raw>
    <mj-section padding="20px 0">
      <mj-column width="40%">
        <mj-image href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
      <mj-column width="60%">
        <mj-navbar base-url="https://example.com" hamburger="hamburger" ico-color="#ffffff">
          <mj-navbar-link color="#ffffff" href="/products">
            Products
          </mj-navbar-link>
          <mj-navbar-link color="#ffffff" href="/features">
            Features
          </mj-navbar-link>
          <mj-navbar-link color="#ffffff" href="/about">
            About
          </mj-navbar-link>
        </mj-navbar>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section with Gradient -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Tech Banner" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591821465514_photo-1451187580459-43490279c0fa.png"></mj-image>
        <mj-text align="center" color="#00FF00" font-size="48px" font-weight="bold" padding-top="20px">
          FUTURE IS NOW
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Stats Grid -->
    </mj-raw>
    <mj-section background-color="#1A1A1A" padding="30px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#00FF00" font-size="36px">
          98%
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Efficiency
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#00FF00" font-size="36px">
          24/7
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Support
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#00FF00" font-size="36px">
          5M+
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Users
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Feature Blocks -->
    </mj-raw>
    <mj-section padding="20px 0">
      <mj-column background-color="#1A1A1A" padding="20px" width="50%">
        <mj-text color="#00FF00" font-size="24px">
          AI Integration
        </mj-text>
        <mj-text color="#ffffff">
          Advanced machine learning algorithms powering next-gen solutions.
        </mj-text>
      </mj-column>
      <mj-column background-color="#1A1A1A" padding="20px" width="50%">
        <mj-text color="#00FF00" font-size="24px">
          Cloud Native
        </mj-text>
        <mj-text color="#ffffff">
          Scalable infrastructure built for the modern web.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- CTA Section -->
    </mj-raw>
    <mj-section background-color="#00FF00" padding="40px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="24px">
          Ready to Transform?
        </mj-text>
        <mj-button background-color="#000000" color="#00FF00">
          GET STARTED
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#1A1A1A">
      <mj-column>
        <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#00FF00" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element background-color="#00FF00" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element background-color="#00FF00" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 TechCorp. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template8",
    title: "Organic Living Newsletter",
    thumbnail: thumb8,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Organic Living Newsletter
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;600" name="Crimson Text"></mj-font>
    <mj-attributes>
      <mj-all font-family="Crimson Text, serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#F5F1E9">
    <mj-raw>
      <!-- Curved Header -->
    </mj-raw>
    <mj-wrapper background-color="#86A97C" padding="0">
      <mj-section padding-top="50px">
        <mj-column>
          <mj-image href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
          <mj-text align="center" color="#ffffff" font-size="32px">
            Natural Living
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
    <mj-raw>
      <!-- Daily Tips -->
    </mj-raw>
    <mj-section background-color="#ffffff" border-radius="10px" padding="40px 25px">
      <mj-column width="30%">
        <mj-image alt="Plant" border-radius="20px" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/3yurdy7tuicuukij4a0rn_image.png" width="200px"></mj-image>
      </mj-column>
      <mj-column width="70%">
        <mj-text color="#4A6741" font-size="24px">
          Today's Eco Tip
        </mj-text>
        <mj-text color="#333333" font-size="16px">
          Start your own herb garden using recycled containers. It's sustainable and adds fresh flavors to your cooking!
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Product Showcase -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Product 1" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918807750112_photo-1487700160041-babef9c3cb55.png"></mj-image>
        <mj-text align="center" color="#4A6741" font-size="18px">
          Organic Tea
        </mj-text>
        <mj-text align="center" color="#666666">
          $24.99
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Product 2" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918807750112_photo-1487700160041-babef9c3cb55.png"></mj-image>
        <mj-text align="center" color="#4A6741" font-size="18px">
          Natural Soap
        </mj-text>
        <mj-text align="center" color="#666666">
          $12.99
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Product 3" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918807750112_photo-1487700160041-babef9c3cb55.png"></mj-image>
        <mj-text align="center" color="#4A6741" font-size="18px">
          Bamboo Set
        </mj-text>
        <mj-text align="center" color="#666666">
          $34.99
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Quote Section -->
    </mj-raw>
    <mj-section background-color="#E8F0E5" padding="40px">
      <mj-column>
        <mj-text align="center" color="#4A6741" font-size="24px" font-style="italic">
          "In nature, nothing is perfect and everything is perfect."
        </mj-text>
        <mj-text align="center" color="#666666">
          - Alice Walker
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Blog Preview -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-text align="center" color="#4A6741" font-size="28px">
          Latest from Our Blog
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="0 20px 20px">
      <mj-column padding="10px" width="50%">
        <mj-image alt="Blog 1" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918822200113_photo-1485637701894-09ad422f6de6_w_600.png"></mj-image>
        <mj-text color="#4A6741" font-size="18px">
          Sustainable Living Tips
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="50%">
        <mj-image alt="Blog 2" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918822200113_photo-1485637701894-09ad422f6de6_w_600.png"></mj-image>
        <mj-text color="#4A6741" font-size="18px">
          Zero Waste Kitchen Guide
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#86A97C" padding="30px">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#4A6741" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element background-color="#4A6741" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element background-color="#4A6741" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          Made with 🌱 by Organic Living
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template9",
    title: "Luxury Fashion Collection",
    thumbnail: thumb9,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Luxury Fashion Collection
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600" name="Didot"></mj-font>
    <mj-attributes>
      <mj-all font-family="Didot, serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#000000">
    <mj-raw>
      <!-- Minimal Header -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column>
        <mj-image href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Full-width Fashion Image -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Fashion" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918842040114_photo-1490481651871-ab68de25d43d_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Golden Divider -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-divider border-color="#B8860B" border-width="1px"></mj-divider>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Collection Title -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#B8860B" font-size="36px" letter-spacing="2px">
          AUTUMN COLLECTION
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="16px" letter-spacing="1px">
          EXCLUSIVELY CURATED PIECES
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Featured Products Grid -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column padding="10px" width="50%">
        <mj-image alt="Product 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918853443115_photo-1539109136881-3be0616acf4b_w_600.png"></mj-image>
        <mj-text align="center" color="#B8860B" font-size="20px">
          Silk Evening Gown
        </mj-text>
        <mj-text align="center" color="#ffffff">
          $2,499
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="50%">
        <mj-image alt="Product 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1735918853443115_photo-1539109136881-3be0616acf4b_w_600.png"></mj-image>
        <mj-text align="center" color="#B8860B" font-size="20px">
          Designer Handbag
        </mj-text>
        <mj-text align="center" color="#ffffff">
          $1,899
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Exclusive Offer -->
    </mj-raw>
    <mj-section background-color="#B8860B" padding="40px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="24px">
          EXCLUSIVE VIP ACCESS
        </mj-text>
        <mj-text align="center" color="#000000">
          Preview the collection before anyone else
        </mj-text>
        <mj-button background-color="#000000" border="1px solid #B8860B" color="#B8860B">
          REQUEST ACCESS
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Boutique Locations -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#B8860B" font-size="20px">
          PARIS
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="14px">
          16 Rue de la Paix
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#B8860B" font-size="20px">
          MILAN
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="14px">
          Montenapoleone
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#B8860B" font-size="20px">
          NEW YORK
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="14px">
          Fifth Avenue, 754
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#000000">
      <mj-column>
        <mj-social align="center" font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#B8860B" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mfpkmlhg2mva_os9dl4p1_image.png"></mj-social-element>
          <mj-social-element background-color="#B8860B" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bc9v51iia1minm3_7hoz_image.png"></mj-social-element>
          <mj-social-element background-color="#B8860B" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yalfxko4tea86assl7rfg_image.png"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Luxury Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template10",
    title: "Kids Learning Adventure",
    thumbnail: thumb10,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Kids Learning Adventure
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600" name="Quicksand"></mj-font>
    <mj-attributes>
      <mj-all font-family="Quicksand, Arial, sans-serif"></mj-all>
      <mj-text color="#4A4A4A" font-size="16px" line-height="1.5"></mj-text>
      <mj-section padding="0 20px"></mj-section>
      <mj-button border-radius="25px" font-size="16px" font-weight="600"></mj-button>
    </mj-attributes>
    <mj-style>
      .rounded-section {
      border-radius: 15px;
      overflow: hidden;
      }
      .activity-card {
      border-radius: 10px;
      overflow: hidden;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#F5F7FA">
    <mj-raw>
      <!-- Header -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column>
        <mj-image alt="Learning Center Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section padding="0 20px">
      <mj-column>
        <mj-image alt="Happy Learning Kids" css-class="rounded-section" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180236634_photo-1516627145497-ae6968895b74.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Welcome Message -->
    </mj-raw>
    <mj-section background-color="#ffffff" css-class="rounded-section">
      <mj-column>
        <mj-text align="center" color="#FF6B6B" font-size="28px" font-weight="600">
          Welcome to Our Learning Adventure! 🌈
        </mj-text>
        <mj-text align="center">
          Where every day brings new discoveries and fun learning experiences
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Featured Activities -->
    </mj-raw>
    <mj-section background-color="#ffffff" css-class="rounded-section">
      <mj-column padding="10px" width="50%">
        <mj-image alt="Creative Arts" css-class="activity-card" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180236634_photo-1516627145497-ae6968895b74.png"></mj-image>
        <mj-text align="center" color="#4A90E2" font-size="20px" padding-top="15px">
          🎨 Creative Arts
        </mj-text>
        <mj-text align="center">
          Express yourself through colors and shapes
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="50%">
        <mj-image alt="Music & Movement" css-class="activity-card" height="200px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180505405_photo-1488521787991-ed7bbaae773c_w_600.png"></mj-image>
        <mj-text align="center" color="#FF6B6B" font-size="20px" padding-top="15px">
          🎵 Music & Movement
        </mj-text>
        <mj-text align="center">
          Dance, sing, and explore rhythm
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Learning Programs -->
    </mj-raw>
    <mj-section background-color="#F8F9FA" css-class="rounded-section">
      <mj-column>
        <mj-text align="center" color="#4A4A4A" font-size="24px" font-weight="600">
          Our Learning Programs
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#F8F9FA" padding-top="0">
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Early Learning" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180715636_photo-1560969184-10fe8719e047_w_600.png"></mj-image>
        <mj-text align="center" color="#4A90E2" font-size="18px">
          Early Learning
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="STEM Activities" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180822957_photo-1509062522246-3755977927d7.png"></mj-image>
        <mj-text align="center" color="#4A90E2" font-size="18px">
          STEM Activities
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Language Arts" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359181061238_photo-1549737328-8b9f3252b927_w_600.png"></mj-image>
        <mj-text align="center" color="#4A90E2" font-size="18px">
          Language Arts
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Special Feature -->
    </mj-raw>
    <mj-section background-color="#FFE0F7" css-class="rounded-section">
      <mj-column width="60%">
        <mj-text color="#9C27B0" font-size="24px" font-weight="600">
          Story Time Adventures
        </mj-text>
        <mj-text>
          Join us every Friday for magical storytelling sessions!
        </mj-text>
        <mj-button background-color="#9C27B0" color="#ffffff">
          Learn More
        </mj-button>
      </mj-column>
      <mj-column width="40%">
        <mj-image alt="Story Time" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359181061238_photo-1549737328-8b9f3252b927_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Parent Resources -->
    </mj-raw>
    <mj-section background-color="#E3F2FD" css-class="rounded-section">
      <mj-column>
        <mj-text align="center" color="#1976D2" font-size="24px" font-weight="600">
          Parent Resources
        </mj-text>
        <mj-text align="center">
          Stay connected with your child's learning journey
        </mj-text>
        <mj-button background-color="#1976D2" color="#ffffff">
          Access Portal
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Photo Gallery -->
    </mj-raw>
    <mj-section background-color="#ffffff" css-class="rounded-section">
      <mj-column>
        <mj-text align="center" color="#4A4A4A" font-size="24px" font-weight="600">
          Learning Moments
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column padding="5px" width="25%">
        <mj-image alt="Gallery 1" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180236634_photo-1516627145497-ae6968895b74.png"></mj-image>
      </mj-column>
      <mj-column padding="5px" width="25%">
        <mj-image alt="Gallery 2" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180505405_photo-1488521787991-ed7bbaae773c_w_600.png"></mj-image>
      </mj-column>
      <mj-column padding="5px" width="25%">
        <mj-image alt="Gallery 3" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359180822957_photo-1509062522246-3755977927d7.png"></mj-image>
      </mj-column>
      <mj-column padding="5px" width="25%">
        <mj-image alt="Gallery 4" css-class="activity-card" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359181061238_photo-1549737328-8b9f3252b927_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-spacer height="20px"></mj-spacer>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#ffffff" css-class="rounded-section">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#4A90E2" href="https://facebook.com" name="facebook"></mj-social-element>
          <mj-social-element background-color="#FF6B6B" href="https://instagram.com" name="instagram"></mj-social-element>
          <mj-social-element background-color="#FF0000" href="https://youtube.com" name="youtube"></mj-social-element>
        </mj-social>
        <mj-text align="center" font-size="14px">
          123 Learning Street, Fun City 12345
        </mj-text>
        <mj-text align="center" font-size="14px">
          © 2024 Kids Learning Center. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template11",
    title: "Fitness & Wellness Newsletter",
    thumbnail: thumb11,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Fitness & Wellness Newsletter
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700" name="Poppins"></mj-font>
    <mj-attributes>
      <mj-all font-family="Poppins, Arial, sans-serif"></mj-all>
      <mj-text color="#333333" font-size="16px" line-height="1.5"></mj-text>
      <mj-section padding="0 20px"></mj-section>
      <mj-button background-color="#FF4757" border-radius="30px"></mj-button>
    </mj-attributes>
    <mj-style>
      .gradient-bg {
      background: linear-gradient(135deg, #FF4757, #FF6B81);
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#F8F9FA">
    <mj-raw>
      <!-- Header -->
    </mj-raw>
    <mj-section css-class="gradient-bg" padding="20px">
      <mj-column>
        <mj-image alt="Fitness Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Fitness Hero" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17359181369539_photo-1517836357463-d25dfeac3438_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Welcome Message -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-text align="center" color="#FF4757" font-size="32px" font-weight="700">
          Transform Your Life
        </mj-text>
        <mj-text align="center">
          Start your fitness journey today with our expert guidance
        </mj-text>
        <mj-button>
          Get Started Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section padding="10px"></mj-section>
    <mj-raw>
      <!-- Featured Programs -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Strength" height="120px" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591814464910_photo-1518611012118-696072aa579a.png"></mj-image>
        <mj-text align="center" color="#FF4757" font-size="18px" font-weight="600">
          Strength
        </mj-text>
        <mj-text align="center" font-size="14px">
          Build muscle & power
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Cardio" height="120px" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591816181911_photo-1518459031867-a89b944bffe4.png"></mj-image>
        <mj-text align="center" color="#FF4757" font-size="18px" font-weight="600">
          Cardio
        </mj-text>
        <mj-text align="center" font-size="14px">
          Boost endurance
        </mj-text>
      </mj-column>
      <mj-column padding="10px" width="33.33%">
        <mj-image alt="Yoga" height="120px" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591818305412_photo-1544367567-0f2fcb009e0b_w_600.png"></mj-image>
        <mj-text align="center" color="#FF4757" font-size="18px" font-weight="600">
          Yoga
        </mj-text>
        <mj-text align="center" font-size="14px">
          Find balance
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding="10px"></mj-section>
    <mj-raw>
      <!-- Trainer Spotlight -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column width="40%">
        <mj-image alt="Trainer" border-radius="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591819442813_photo-1571019614242-c5c5dee9f50b_w_600.png"></mj-image>
      </mj-column>
      <mj-column width="60%">
        <mj-text font-size="24px" font-weight="600">
          Meet Your Trainer
        </mj-text>
        <mj-text>
          "I believe in making fitness accessible and enjoyable for everyone. Let's work together to achieve your goals!"
        </mj-text>
        <mj-text font-weight="600">
          - Alex Thompson
        </mj-text>
        <mj-button>
          Book a Session
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section padding="10px"></mj-section>
    <mj-raw>
      <!-- Class Schedule -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-text align="center" font-size="24px" font-weight="600">
          This Week's Schedule
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column>
        <mj-table>
          <tr style="border-bottom: 1px solid #eeeeee;">
            <td style="padding: 15px;">Monday</td>
            <td style="padding: 15px;">HIIT Training</td>
            <td style="padding: 15px;">6:00 AM</td>
          </tr>
          <tr style="border-bottom: 1px solid #eeeeee;">
            <td style="padding: 15px;">Wednesday</td>
            <td style="padding: 15px;">Strength & Core</td>
            <td style="padding: 15px;">7:00 AM</td>
          </tr>
          <tr style="border-bottom: 1px solid #eeeeee;">
            <td style="padding: 15px;">Friday</td>
            <td style="padding: 15px;">Yoga Flow</td>
            <td style="padding: 15px;">8:00 AM</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <mj-section padding="10px"></mj-section>
    <mj-raw>
      <!-- Success Story -->
    </mj-raw>
    <mj-section background-color="#F8F9FA">
      <mj-column width="50%">
        <mj-image alt="Success Story" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591819442813_photo-1571019614242-c5c5dee9f50b_w_600.png"></mj-image>
      </mj-column>
      <mj-column width="50%">
        <mj-text font-size="24px" font-weight="600">
          Success Story
        </mj-text>
        <mj-text>
          "I lost 30 pounds and gained confidence. The trainers here are amazing!"
        </mj-text>
        <mj-text font-weight="600">
          - Sarah M.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding="10px"></mj-section>
    <mj-raw>
      <!-- Special Offer -->
    </mj-raw>
    <mj-section css-class="gradient-bg">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="600">
          Special Offer
        </mj-text>
        <mj-text align="center" color="#ffffff">
          Join now and get 30% off your first month!
        </mj-text>
        <mj-button background-color="#ffffff" color="#FF4757">
          Claim Offer
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#333333">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#FF4757" href="https://instagram.com" name="instagram"></mj-social-element>
          <mj-social-element background-color="#FF4757" href="https://facebook.com" name="facebook"></mj-social-element>
          <mj-social-element background-color="#FF4757" href="https://twitter.com" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          123 Fitness Street, Healthy City, HC 12345
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Fitness Center. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template12",
    title: "Tech Newsletter",
    thumbnail: thumb12,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Tech Newsletter
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600" name="Inter"></mj-font>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif"></mj-all>
      <mj-text color="#333333" font-size="16px" line-height="1.5"></mj-text>
      <mj-section padding="0 20px"></mj-section>
      <mj-button background-color="#000000" border-radius="0"></mj-button>
    </mj-attributes>
    <mj-style>
      .border-bottom { border-bottom: 1px solid #eee; }
    </mj-style>
  </mj-head>
  <mj-body background-color="#ffffff">
    <mj-raw>
      <!-- Header -->
    </mj-raw>
    <mj-section padding="40px 20px">
      <mj-column>
        <mj-text align="center" font-size="24px" font-weight="600">
          TECH/MINIMAL
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section>
      <mj-column width="100%">
        <mj-image alt="Tech Hero" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591821465514_photo-1451187580459-43490279c0fa.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Spacer -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-spacer height="40px"></mj-spacer>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Main Content -->
    </mj-raw>
    <mj-section>
      <mj-column width="100%">
        <mj-text font-size="32px" font-weight="600">
          The Future of Design
        </mj-text>
        <mj-text color="#666666">
          Exploring minimalism in modern technology
        </mj-text>
        <mj-button padding="20px 0">
          Read More →
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Spacer -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-spacer height="40px"></mj-spacer>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Grid Content -->
    </mj-raw>
    <mj-section>
      <mj-column padding-right="20px" width="50%">
        <mj-image alt="Tech 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591822706915_photo-1498050108023-c5249f4df085.png"></mj-image>
        <mj-text font-size="20px" font-weight="600" padding-top="20px">
          Clean Code
        </mj-text>
        <mj-text color="#666666">
          The art of writing elegant solutions
        </mj-text>
      </mj-column>
      <mj-column padding-left="20px" width="50%">
        <mj-image alt="Tech 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591821465514_photo-1451187580459-43490279c0fa.png"></mj-image>
        <mj-text font-size="20px" font-weight="600" padding-top="20px">
          Future Tech
        </mj-text>
        <mj-text color="#666666">
          Emerging trends in technology
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Spacer -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-spacer height="40px"></mj-spacer>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Feature Section -->
    </mj-raw>
    <mj-section background-color="#f8f8f8">
      <mj-column>
        <mj-text align="center" font-size="24px" font-weight="600">
          Latest Updates
        </mj-text>
        <mj-table>
          <tr style="border-bottom: 1px solid #eee;">
            <td style="padding: 15px 0;">AI Development</td>
            <td style="padding: 15px 0; text-align: right;">→</td>
          </tr>
          <tr style="border-bottom: 1px solid #eee;">
            <td style="padding: 15px 0;">Cloud Computing</td>
            <td style="padding: 15px 0; text-align: right;">→</td>
          </tr>
          <tr>
            <td style="padding: 15px 0;">Cybersecurity</td>
            <td style="padding: 15px 0; text-align: right;">→</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Spacer -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-spacer height="40px"></mj-spacer>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- CTA Section -->
    </mj-raw>
    <mj-section>
      <mj-column>
        <mj-text align="center" font-size="24px" font-weight="600">
          Stay Updated
        </mj-text>
        <mj-text align="center" color="#666666">
          Get the latest tech news delivered to your inbox
        </mj-text>
        <mj-button>
          Subscribe Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#f8f8f8" padding="40px 20px">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#000000" href="https://twitter.com" name="twitter"></mj-social-element>
          <mj-social-element background-color="#000000" href="https://linkedin.com" name="linkedin"></mj-social-element>
          <mj-social-element background-color="#000000" href="https://github.com" name="github"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Tech/Minimal. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template13",
    title: "Welcome 2024 - New Year, New Beginnings!",
    thumbnail: thumb13,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Welcome 2024 - New Year, New Beginnings!
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Helvetica" name="Helvetica"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#f4f4f4">
    <mj-raw>
      <!-- Header -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-bottom="0">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Hero Section -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column>
        <mj-image alt="New Year Celebration" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591824498016_photo-1467810563316-b5476525c0f9_w_800_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#1B1B1B" font-size="30px" font-weight="bold" padding-top="20px">
          Celebrate The New Year In Style
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px" line-height="24px">
          Start 2024 with amazing deals and new collections
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Featured Products -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column width="50%">
        <mj-image alt="New Collection" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591824862917_photo-1513519245088-0e12902e5a38_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#1B1B1B" font-size="20px" font-weight="bold">
          New Year Collection
        </mj-text>
        <mj-text align="center" color="#666666" font-size="15px">
          Up to 40% OFF
        </mj-text>
        <mj-button background-color="#2C5282" color="white" href="#">
          Shop Now
        </mj-button>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Bestsellers" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591825139118_photo-1543007630-9710e4a00a20_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#1B1B1B" font-size="20px" font-weight="bold">
          Bestsellers 2023
        </mj-text>
        <mj-text align="center" color="#666666" font-size="15px">
          Special Prices
        </mj-text>
        <mj-button background-color="#2C5282" color="white" href="#">
          Shop Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- New Year Countdown -->
    </mj-raw>
    <mj-section background-color="#2C5282">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="bold">
          New Year Special Offer
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="16px">
          Extra 20% OFF on orders above $100
        </mj-text>
        <mj-button background-color="#ffffff" color="#2C5282" href="#">
          Use Code: HAPPY2024
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Message Section -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-text align="center" color="#666666" font-size="16px" line-height="24px">
          Thank you for being with us in 2023. We're excited to bring you more amazing products and experiences in 2024!
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Footer -->
    </mj-raw>
    <mj-section background-color="#1B1B1B">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px">
          Follow Us
        </mj-text>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="12px">
          You received this email because you signed up for our newsletter.
          <a href="{{unsubscribeUrl}}" style="color: white;">Unsubscribe</a>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template14",
    title: "Love is in the Air - Valentine's Day Special",
    thumbnail: thumb14,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Love is in the Air - Valentine's Day Special
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Playfair+Display" name="Playfair Display"></mj-font>
    <mj-attributes>
      <mj-all font-family="Playfair Display, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#FFF5F5">
    <mj-section background-color="#ffffff" padding="0">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding-top="0">
      <mj-column width="100%">
        <mj-text align="center" color="#FF1493" font-family="Playfair Display" font-size="40px" font-weight="bold">
          ♥ Love is in the Air ♥
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column width="33.33%">
        <mj-image alt="Gift 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591825917119_photo-1518199266791-5375a83190b7_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#FF1493" font-size="18px">
          For Her
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Gift 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591826306220_photo-1549465220-1a8b9238cd48_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#FF1493" font-size="18px">
          For Him
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Gift 3" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591826551321_photo-1515934751635-c81c6bc9a2d8_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#FF1493" font-size="18px">
          For Both
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#FF1493" padding="20px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          Special Valentine's Offer
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="30px" font-weight="bold">
          20% OFF
        </mj-text>
        <mj-button background-color="#ffffff" border-radius="25px" color="#FF1493">
          Shop Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-repeat="no-repeat" background-size="cover" background-url="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591826800822_photo-1518895949257-7621c3c786d7_w_600_h_200_fit_crop.png" padding="50px 20px">
      <mj-column background-color="rgb(255, 255, 255)" padding="20px">
        <mj-text align="center" color="#FF1493" font-size="20px" line-height="1.5">
          "Love is not about how many days, months, or years you have been together. Love is about how much you love each other every single day."
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-social font-size="15px" icon-color="#FF1493" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#666666" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template15",
    title: "Hop into Easter Joy!",
    thumbnail: thumb15,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Hop into Easter Joy!
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Comic+Sans+MS" name="Comic Sans MS"></mj-font>
    <mj-attributes>
      <mj-all font-family="Comic Sans MS, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#E6F9FF">
    <mj-wrapper background-color="#ffffff" padding="0">
      <mj-section padding="0">
        <mj-column>
          <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
        </mj-column>
      </mj-section>
      <mj-section background-color="#FFE5F4" padding-bottom="0">
        <mj-column width="50%">
          <mj-text align="left" color="#9B6B9E" font-size="36px" padding-bottom="0">
            Hop Into
          </mj-text>
          <mj-text align="left" color="#9B6B9E" font-size="48px" font-weight="bold" padding-top="0">
            Easter Joy!
          </mj-text>
          <mj-button background-color="#9B6B9E" border-radius="30px" href="#">
            Shop Easter Collection
          </mj-button>
        </mj-column>
        <mj-column width="50%">
          <mj-image alt="Easter Eggs" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/8hercblsxeemnvkuxkhnv_image.png"></mj-image>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column width="100%">
          <mj-text align="center" color="#9B6B9E" font-size="24px" font-weight="bold">
            Easter Basket Must-Haves
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column width="25%">
          <mj-image alt="Easter Item 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591827961524_photo-1521341057461-6eb5f40b07ab_w_200_h_200_fit_crop.png"></mj-image>
          <mj-text align="center" color="#9B6B9E" font-size="16px">
            Easter Treats
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Easter Item 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591828360725_photo-1552913903-2cffa1962dc7_w_200_h_200_fit_crop.png"></mj-image>
          <mj-text align="center" color="#9B6B9E" font-size="16px">
            Spring Decor
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Easter Item 3" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591828360725_photo-1552913903-2cffa1962dc7_w_200_h_200_fit_crop.png"></mj-image>
          <mj-text align="center" color="#9B6B9E" font-size="16px">
            Kids' Gifts
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Easter Item 4" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591828619026_photo-1557672172-298e090bd0f1_w_200_h_200_fit_crop.png"></mj-image>
          <mj-text align="center" color="#9B6B9E" font-size="16px">
            Easter Outfits
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#E6F9FF" padding="20px">
        <mj-column>
          <mj-text align="center" color="#9B6B9E" font-size="24px" font-weight="bold">
            🐰 Easter Special 🐰
          </mj-text>
          <mj-text align="center" color="#9B6B9E" font-size="18px">
            Use code: EASTERJOY
          </mj-text>
          <mj-text align="center" color="#9B6B9E" font-size="36px" font-weight="bold">
            25% OFF
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column>
          <mj-social font-size="15px" icon-color="#9B6B9E" icon-size="30px" mode="horizontal">
            <mj-social-element href="#" name="facebook"></mj-social-element>
            <mj-social-element href="#" name="instagram"></mj-social-element>
            <mj-social-element href="#" name="twitter"></mj-social-element>
          </mj-social>
          <mj-text align="center" color="#666666" font-size="12px">
            © 2024 Your Brand. All rights reserved.
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`,
  },
  {
    id: "template16",
    title: "Thanksgiving Celebration",
    thumbnail: thumb16,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Thanksgiving Celebration
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Georgia" name="Georgia"></mj-font>
    <mj-attributes>
      <mj-all font-family="Georgia, serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#FFF8DC">
    <mj-section background-color="#8B4513" padding="10px">
      <mj-column>
        <mj-text align="center" color="#FFF8DC" font-size="14px">
          Free Shipping on Orders Over $75 | Use Code: GRATEFUL
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-repeat="no-repeat" background-size="cover" background-url="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591829344827_photo-1506459225024-1428097a7e18_w_900_h_400_fit_crop.png">
      <mj-column background-color="rgb(255, 248, 220)" padding="20px" width="70%">
        <mj-text align="center" color="#8B4513" font-size="40px" font-weight="bold">
          Thanksgiving Sale
        </mj-text>
        <mj-text align="center" color="#8B4513" font-size="24px">
          Up to 40% Off
        </mj-text>
        <mj-button background-color="#8B4513" border-radius="0" color="#FFF8DC">
          Shop Now
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column width="100%">
        <mj-text align="center" color="#8B4513" font-size="28px" font-weight="bold">
          Thanksgiving Essentials
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column width="33.33%">
        <mj-image alt="Dining" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591829724428_photo-1574672280600-4accfa5b6f98_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#8B4513" font-size="20px">
          Dining & Entertaining
        </mj-text>
        <mj-button background-color="#8B4513" color="#FFF8DC">
          Shop Dining
        </mj-button>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Decor" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591829724428_photo-1574672280600-4accfa5b6f98_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#8B4513" font-size="20px">
          Fall Decor
        </mj-text>
        <mj-button background-color="#8B4513" color="#FFF8DC">
          Shop Decor
        </mj-button>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Kitchen" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591829724428_photo-1574672280600-4accfa5b6f98_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#8B4513" font-size="20px">
          Kitchen Must-Haves
        </mj-text>
        <mj-button background-color="#8B4513" color="#FFF8DC">
          Shop Kitchen
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#FFF8DC">
      <mj-column>
        <mj-text align="center" color="#8B4513" font-size="24px" font-style="italic">
          "Gratitude turns what we have into enough"
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#8B4513">
      <mj-column>
        <mj-text align="center" color="#FFF8DC" font-size="24px">
          Early Bird Special
        </mj-text>
        <mj-text align="center" color="#FFF8DC" font-size="18px">
          Extra 15% off when you shop before November 20th
        </mj-text>
        <mj-button background-color="#FFF8DC" color="#8B4513">
          Shop Early
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-social font-size="15px" icon-color="#8B4513" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#8B4513" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template17",
    title: "Magical Christmas Sale",
    thumbnail: thumb17,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Magical Christmas Sale
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Poppins" name="Poppins"></mj-font>
    <mj-attributes>
      <mj-all font-family="Poppins, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#0C3823">
    <mj-section background-color="#ffffff" padding="10px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-text align="center" color="#C41E3A" font-size="42px" font-weight="bold">
          🎄 Magical Christmas Sale 🎄
        </mj-text>
        <mj-text align="center" color="#0C3823" font-size="24px">
          Up to 50% Off Everything
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column width="50%">
        <mj-image alt="Christmas Gifts" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591830471129_photo-1606830733744-0ad778449672_w_400_h_500_fit_crop.png"></mj-image>
        <mj-text align="center" color="#C41E3A" font-size="24px" padding-top="20px">
          Holiday Gifts
        </mj-text>
        <mj-button background-color="#0C3823" color="white">
          Shop Gifts
        </mj-button>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Christmas Decor" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591830835330_photo-1607344645866-009c320b63e0_w_400_h_500_fit_crop.png"></mj-image>
        <mj-text align="center" color="#C41E3A" font-size="24px" padding-top="20px">
          Christmas Decor
        </mj-text>
        <mj-button background-color="#0C3823" color="white">
          Shop Decor
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#C41E3A" padding="20px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="30px">
          🎅 SANTA'S SPECIAL 🎅
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="20px">
          Extra 20% Off with code: SANTA2024
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="For Her" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591831090631_photo-1543258103-a62bdc069871_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#0C3823" font-size="18px">
          For Her
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="For Him" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591831408632_photo-1513885535751-8b9238bd345a_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#0C3823" font-size="18px">
          For Him
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="For Kids" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591831659633_photo-1512909006721-3d6018887383_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#0C3823" font-size="18px">
          For Kids
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#0C3823" padding="20px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          🎄 Holiday Shipping Deadlines 🎄
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="16px">
          Order by December 20th for Christmas Delivery
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#0C3823" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template18",
    title: "Celebrate Dad - Father's Day Specials",
    thumbnail: thumb18,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Celebrate Dad - Father's Day Specials
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Roboto" name="Roboto"></mj-font>
    <mj-attributes>
      <mj-all font-family="Roboto, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#E8EAF6">
    <mj-wrapper background-color="#ffffff" padding="0">
      <mj-section padding="0">
        <mj-column>
          <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
        </mj-column>
      </mj-section>
      <mj-section background-color="#1A237E" padding="20px">
        <mj-column>
          <mj-text align="center" color="#ffffff" font-size="42px" font-weight="bold">
            For The World's Best Dad
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#E8EAF6" padding="0">
        <mj-column padding="0" width="50%">
          <mj-image alt="Father's Day" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591832457334_photo-1490114538077-0a7f8cb49891_w_500_h_300_fit_crop.png"></mj-image>
        </mj-column>
        <mj-column background-color="#E8EAF6" width="50%">
          <mj-text align="center" color="#1A237E" font-size="24px" padding="20px">
            Father's Day Collection
          </mj-text>
          <mj-text align="center" color="#3949AB" font-size="16px">
            Find the perfect gift for dad
          </mj-text>
          <mj-button background-color="#1A237E" border-radius="0">
            Shop Now
          </mj-button>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column width="100%">
          <mj-text align="center" color="#1A237E" font-size="28px" font-weight="bold">
            Top Picks for Dad
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column width="25%">
          <mj-image alt="Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591832927535_photo-1523170335258-f5ed11844a49_w_300_h_300_fit_crop.png"></mj-image>
          <mj-text align="center" color="#1A237E" font-size="16px">
            Watches
          </mj-text>
          <mj-text align="center" color="#3949AB" font-size="14px">
            From $199
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Shoes" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591833150336_photo-1491553895911-0055eca6402d_w_300_h_300_fit_crop.png"></mj-image>
          <mj-text align="center" color="#1A237E" font-size="16px">
            Sport Gear
          </mj-text>
          <mj-text align="center" color="#3949AB" font-size="14px">
            From $89
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Gadgets" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591833363137_photo-1585386959984-a4155224a1ad_w_300_h_300_fit_crop.png"></mj-image>
          <mj-text align="center" color="#1A237E" font-size="16px">
            Tech Gadgets
          </mj-text>
          <mj-text align="center" color="#3949AB" font-size="14px">
            From $149
          </mj-text>
        </mj-column>
        <mj-column width="25%">
          <mj-image alt="Accessories" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591833573338_photo-1559563458-527698bf5295_w_300_h_300_fit_crop.png"></mj-image>
          <mj-text align="center" color="#1A237E" font-size="16px">
            Accessories
          </mj-text>
          <mj-text align="center" color="#3949AB" font-size="14px">
            From $49
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#1A237E">
        <mj-column>
          <mj-text align="center" color="#ffffff" font-size="24px">
            Limited Time Offer
          </mj-text>
          <mj-text align="center" color="#ffffff" font-size="36px" font-weight="bold">
            SAVE 25%
          </mj-text>
          <mj-text align="center" color="#ffffff" font-size="18px">
            Use code: BESTDAD
          </mj-text>
          <mj-button background-color="#ffffff" color="#1A237E">
            Claim Offer
          </mj-button>
        </mj-column>
      </mj-section>
      <mj-section background-color="#E8EAF6">
        <mj-column>
          <mj-text align="center" color="#1A237E" font-size="20px">
            Free Shipping on Orders Over $100
          </mj-text>
        </mj-column>
      </mj-section>
      <mj-section background-color="#ffffff">
        <mj-column>
          <mj-social font-size="15px" icon-color="#1A237E" icon-size="30px" mode="horizontal">
            <mj-social-element href="#" name="facebook"></mj-social-element>
            <mj-social-element href="#" name="instagram"></mj-social-element>
            <mj-social-element href="#" name="twitter"></mj-social-element>
          </mj-social>
          <mj-text align="center" color="#666666" font-size="12px">
            © 2024 Your Brand. All rights reserved.
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`,
  },
  {
    id: "template19",
    title: "BLACK FRIDAY MEGA SALE",
    thumbnail: thumb19,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY MEGA SALE
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Helvetica" name="Helvetica"></mj-font>
    <mj-attributes>
      <mj-all font-family="Helvetica, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#000000">
    <mj-raw>
      <!-- 顶部通知栏 -->
    </mj-raw>
    <mj-section background-color="#FF0000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="16px" font-weight="bold">
          BIGGEST SALE OF THE YEAR! UP TO 70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Logo部分 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 主标题部分 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="50px" font-weight="bold">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="30px" font-weight="bold">
          MEGA SALE
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 倒计时部分 -->
    </mj-raw>
    <mj-section background-color="#FF0000">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="bold">
          DEALS END SOON
        </mj-text>
        <mj-button background-color="#000000" color="#ffffff" font-size="16px" font-weight="bold">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 热门分类 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591834411939_photo-1483985988355-763728e1935b_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" font-weight="bold">
          Fashion
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="20px">
          Up to 60% OFF
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Electronics" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591834941040_photo-1468495244123-6c6c332eeece_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" font-weight="bold">
          Electronics
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="20px">
          Up to 70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 更多优惠类别 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column width="33.33%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591833150336_photo-1491553895911-0055eca6402d_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px">
          Footwear
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="16px">
          50% OFF
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Accessories" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591835187441_photo-1526170375885-4d8ecf77b99f_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px">
          Accessories
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="16px">
          40% OFF
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Home Decor" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591835438842_photo-1555529669-e69e7aa0ba9a_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px">
          Home Decor
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="16px">
          45% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 额外优惠码 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          EXTRA 10% OFF
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="20px" font-weight="bold">
          Use Code: BLACKFRIDAY
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 配送信息 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="18px">
          🚚 Free Shipping on Orders Over $50
        </mj-text>
        <mj-text align="center" color="#000000" font-size="18px">
          ⚡ Same Day Dispatch
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#000000">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template20",
    title: "BLACK FRIDAY LUXURY DEALS",
    thumbnail: thumb20,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY LUXURY DEALS
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Montserrat:400,700" name="Montserrat"></mj-font>
    <mj-attributes>
      <mj-all font-family="Montserrat, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#1a1a1a">
    <mj-raw>
      <!-- 顶部倒计时条 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="15px">
      <mj-column>
        <mj-text align="center" color="#ffd700" font-size="16px" font-weight="bold">
          EXCLUSIVE EARLY ACCESS - 24 HOURS ONLY
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Logo区域 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 主视觉区域 -->
    </mj-raw>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Luxury Fashion" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591836568243_photo-1483985988355-763728e1935b_w_800_h_500_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 金色标题区 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffd700" font-size="50px" font-weight="bold" line-height="1.2">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px" padding-top="20px">
          LUXURY DEALS UP TO 70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 三列精选商品 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="40px 20px">
      <mj-column padding="0 10px" width="33.33%">
        <mj-image alt="Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591837247144_photo-1549298916-b41d501d3772_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px" font-weight="bold" padding-top="20px">
          DESIGNER BAGS
        </mj-text>
        <mj-text align="center" color="#ffd700" font-size="16px" font-weight="bold">
          UP TO 60% OFF
        </mj-text>
      </mj-column>
      <mj-column padding="0 10px" width="33.33%">
        <mj-image alt="Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591837586545_photo-1523275335684-37898b6baf30_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px" font-weight="bold" padding-top="20px">
          LUXURY WATCHES
        </mj-text>
        <mj-text align="center" color="#ffd700" font-size="16px" font-weight="bold">
          UP TO 50% OFF
        </mj-text>
      </mj-column>
      <mj-column padding="0 10px" width="33.33%">
        <mj-image alt="Jewelry" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591837815146_photo-1582588678413-dbf45f4823e9_w_300_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="18px" font-weight="bold" padding-top="20px">
          FINE JEWELRY
        </mj-text>
        <mj-text align="center" color="#ffd700" font-size="16px" font-weight="bold">
          UP TO 70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- VIP优惠码 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffd700" font-size="24px" font-weight="bold">
          EXCLUSIVE VIP CODE
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="36px" font-weight="bold" padding-top="10px">
          LUXVIP2024
        </mj-text>
        <mj-text align="center" color="#ffd700" font-size="18px" padding-top="10px">
          Extra 15% Off on All Items
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 热门品类 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="40px 20px">
      <mj-column padding="0 10px" width="50%">
        <mj-image alt="Women" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591838082147_photo-1490481651871-ab68de25d43d_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" font-weight="bold" padding-top="20px">
          WOMEN
        </mj-text>
        <mj-button background-color="#000000" color="#ffffff" font-weight="bold">
          SHOP NOW
        </mj-button>
      </mj-column>
      <mj-column padding="0 10px" width="50%">
        <mj-image alt="Men" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591838308048_photo-1617137968427-85924c800a22_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" font-weight="bold" padding-top="20px">
          MEN
        </mj-text>
        <mj-button background-color="#000000" color="#ffffff" font-weight="bold">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 配送信息 -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding="30px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#ffffff" font-size="14px">
          ✈️ FREE SHIPPING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#ffffff" font-size="14px">
          🔒 SECURE PAYMENT
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#ffffff" font-size="14px">
          ↩️ EASY RETURNS
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffd700" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px" padding-top="20px">
          © 2024 Your Luxury Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template21",
    title: "Cyber Monday - Biggest Online Deals",
    thumbnail: thumb21,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Cyber Monday - Biggest Online Deals
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Roboto" name="Roboto"></mj-font>
    <mj-attributes>
      <mj-all font-family="Roboto, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#001933">
    <mj-raw>
      <!-- 顶部通知栏 -->
    </mj-raw>
    <mj-section background-color="#00FFFF" padding="10px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="16px" font-weight="bold">
          24 HOURS ONLY! CYBER MONDAY DEALS END SOON
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Logo部分 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 主标题部分 -->
    </mj-raw>
    <mj-section background-color="#000033" padding="30px">
      <mj-column>
        <mj-text align="center" color="#00FFFF" font-size="46px" font-weight="bold">
          CYBER MONDAY
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="28px">
          UP TO 80% OFF ONLINE
        </mj-text>
        <mj-button background-color="#00FFFF" border-radius="5px" color="#000033" font-size="18px" font-weight="bold">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 热门科技产品 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Tech Deals" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591838997149_photo-1544731612-de7f96afe55f_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000033" font-size="24px" font-weight="bold">
          Tech Deals
        </mj-text>
        <mj-text align="center" color="#001933" font-size="20px">
          Up to 70% OFF
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Gadgets" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591839364650_photo-1587033411391-5d9e51cce126_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000033" font-size="24px" font-weight="bold">
          Smart Gadgets
        </mj-text>
        <mj-text align="center" color="#001933" font-size="20px">
          Up to 60% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 闪购特惠 -->
    </mj-raw>
    <mj-section background-color="#00FFFF" padding="20px">
      <mj-column>
        <mj-text align="center" color="#000033" font-size="30px" font-weight="bold">
          ⚡ FLASH DEALS ⚡
        </mj-text>
        <mj-text align="center" color="#000033" font-size="20px">
          Extra 15% off with code: CYBER15
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 产品分类 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column width="33.33%">
        <mj-image alt="Laptops" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591839668451_photo-1505751172876-fa1923c5c528_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000033" font-size="18px">
          Laptops
        </mj-text>
        <mj-text align="center" color="#001933" font-size="16px">
          From $399
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Smart Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591839960752_photo-1546868871-7041f2a55e12_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000033" font-size="18px">
          Smart Watches
        </mj-text>
        <mj-text align="center" color="#001933" font-size="16px">
          From $99
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Headphones" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591840211253_photo-1585298723682-7115561c51b7_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000033" font-size="18px">
          Headphones
        </mj-text>
        <mj-text align="center" color="#001933" font-size="16px">
          From $49
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 限时优惠 -->
    </mj-raw>
    <mj-section background-color="#000033" padding="20px">
      <mj-column>
        <mj-text align="center" color="#00FFFF" font-size="24px">
          🕒 LIMITED TIME OFFER
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="18px">
          Free Next Day Delivery on Orders Over $100
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 购物保障 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-text align="center" color="#000033" font-size="16px">
          ✓ Secure Payment
        </mj-text>
        <mj-text align="center" color="#000033" font-size="16px">
          ✓ 30-Day Returns
        </mj-text>
        <mj-text align="center" color="#000033" font-size="16px">
          ✓ 24/7 Support
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#000033">
      <mj-column>
        <mj-social font-size="15px" icon-color="#00FFFF" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="12px">
          *Offers valid online only. Terms and conditions apply.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template22",
    title: "BLACK FRIDAY EXCLUSIVE",
    thumbnail: thumb22,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY EXCLUSIVE
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Oswald:400,700" name="Oswald"></mj-font>
    <mj-attributes>
      <mj-all font-family="Oswald, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#000000">
    <mj-raw>
      <!-- 顶部通知栏 -->
    </mj-raw>
    <mj-section background-color="#FF0000">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px" padding="8px">
          🔥 EARLY ACCESS STARTS NOW - PRICES DROP AT MIDNIGHT 🔥
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Logo -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="120px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 分割设计主视觉 -->
    </mj-raw>
    <mj-section>
      <mj-column background-color="#000000" width="50%">
        <mj-text align="right" color="#ffffff" font-size="120px" font-weight="bold" padding="40px 0">
          BL
        </mj-text>
        <mj-text align="right" color="#FF0000" font-size="30px" padding="0 20px 40px 0">
          UP TO
        </mj-text>
      </mj-column>
      <mj-column background-color="#FF0000" width="50%">
        <mj-text align="left" color="#000000" font-size="120px" font-weight="bold" padding="40px 0">
          ACK
        </mj-text>
        <mj-text align="left" color="#ffffff" font-size="60px" padding="0 0 40px 20px">
          70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 对角线设计区块 -->
    </mj-raw>
    <mj-section>
      <mj-column background-color="#ffffff" padding="20px" width="33.33%">
        <mj-image alt="Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591840829254_photo-1523275335684-37898b6baf30_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding-top="15px">
          WATCHES
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="18px" padding-top="5px">
          50% OFF
        </mj-text>
      </mj-column>
      <mj-column background-color="#000000" padding="20px" width="33.33%">
        <mj-image alt="Headphones" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591841116955_photo-1505740420928-5e560c06d30e_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="24px" padding-top="15px">
          AUDIO
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="18px" padding-top="5px">
          60% OFF
        </mj-text>
      </mj-column>
      <mj-column background-color="#ffffff" padding="20px" width="33.33%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591833150336_photo-1491553895911-0055eca6402d_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding-top="15px">
          FOOTWEAR
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="18px" padding-top="5px">
          70% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 交错布局展示区 -->
    </mj-raw>
    <mj-section>
      <mj-column width="60%">
        <mj-image alt="Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591841421756_photo-1483985988355-763728e1935b_w_500_h_300_fit_crop.png"></mj-image>
      </mj-column>
      <mj-column background-color="#FF0000" padding="20px" width="40%">
        <mj-text align="center" color="#ffffff" font-size="28px" padding="20px">
          FASHION
        </mj-text>
        <mj-button background-color="#000000" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column background-color="#000000" padding="20px" width="40%">
        <mj-text align="center" color="#ffffff" font-size="28px" padding="20px">
          TECH
        </mj-text>
        <mj-button background-color="#FF0000" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
      <mj-column width="60%">
        <mj-image alt="Tech" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591841708357_photo-1468495244123-6c6c332eeece_w_500_h_300_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 优惠码特殊设计 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column background-color="#000000" width="15%">
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          GET
        </mj-text>
      </mj-column>
      <mj-column background-color="#FF0000" width="70%">
        <mj-text align="center" color="#ffffff" font-size="32px" font-weight="bold" padding="20px">
          EXTRA 20% OFF: BLACKFRI20
        </mj-text>
      </mj-column>
      <mj-column background-color="#000000" width="15%">
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          NOW
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 倒计时区域 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          DEALS END IN
        </mj-text>
        <mj-text align="center" color="#FF0000" font-size="40px" font-weight="bold">
          24:00:00
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 快速分类导航 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="20%">
        <mj-text align="center" color="#000000" font-size="16px">
          WOMEN
        </mj-text>
      </mj-column>
      <mj-column width="20%">
        <mj-text align="center" color="#000000" font-size="16px">
          MEN
        </mj-text>
      </mj-column>
      <mj-column width="20%">
        <mj-text align="center" color="#000000" font-size="16px">
          KIDS
        </mj-text>
      </mj-column>
      <mj-column width="20%">
        <mj-text align="center" color="#000000" font-size="16px">
          BEAUTY
        </mj-text>
      </mj-column>
      <mj-column width="20%">
        <mj-text align="center" color="#000000" font-size="16px">
          HOME
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 配送信息 -->
    </mj-raw>
    <mj-section background-color="#f8f8f8" padding="20px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="14px">
          ✈️ FREE SHIPPING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="14px">
          🔄 30 DAYS RETURN
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="14px">
          🔒 SECURE PAYMENT
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template23",
    title: "BLACK FRIDAY SPORTS DEALS",
    thumbnail: thumb23,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY SPORTS DEALS
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Anton" name="Nike"></mj-font>
    <mj-attributes>
      <mj-all font-family="Anton, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#f2f2f2">
    <mj-section background-color="#000000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="16px">
          BIGGEST SPORTS SALE OF THE YEAR 🏃‍♂️
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Sports" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591842442958_photo-1517836357463-d25dfeac3438_w_800_h_400_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ff4d4d" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="48px">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px">
          UP TO 70% OFF ALL GEAR
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843298659_photo-1542291026-7eec264c27ff_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px">
          FOOTWEAR
        </mj-text>
        <mj-button background-color="#ff4d4d" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Apparel" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843581960_photo-1515886657613-9f3515b0c78f_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px">
          APPAREL
        </mj-text>
        <mj-button background-color="#ff4d4d" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#000000" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="Basketball" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843925361_photo-1517649763962-0c623066013b_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          BASKETBALL
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Running" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591844305562_photo-1579952363873-27f3bade9f55_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          RUNNING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Training" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591844543163_photo-1593419528756-3cdfa1615b86_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          TRAINING
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ff4d4d">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          EXTRA 20% OFF WITH CODE: SPORT20
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#000000">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Your Sports Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template24",
    title: "BLACK FRIDAY SPORTS DEALS",
    thumbnail: thumb24,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY SPORTS DEALS
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Anton" name="Nike"></mj-font>
    <mj-attributes>
      <mj-all font-family="Anton, Arial, sans-serif"></mj-all>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#f2f2f2">
    <mj-section background-color="#000000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="16px">
          BIGGEST SPORTS SALE OF THE YEAR 🏃‍♂️
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Sports" padding="0" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591842442958_photo-1517836357463-d25dfeac3438_w_800_h_400_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ff4d4d" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="48px">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px">
          UP TO 70% OFF ALL GEAR
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843298659_photo-1542291026-7eec264c27ff_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px">
          FOOTWEAR
        </mj-text>
        <mj-button background-color="#ff4d4d" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Apparel" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843581960_photo-1515886657613-9f3515b0c78f_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px">
          APPAREL
        </mj-text>
        <mj-button background-color="#ff4d4d" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#000000" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="Basketball" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591843925361_photo-1517649763962-0c623066013b_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          BASKETBALL
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Running" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591844305562_photo-1579952363873-27f3bade9f55_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          RUNNING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Training" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591844543163_photo-1593419528756-3cdfa1615b86_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="18px">
          TRAINING
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ff4d4d">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          EXTRA 20% OFF WITH CODE: SPORT20
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#000000">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px">
          © 2024 Your Sports Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template25",
    title: "BLACK FRIDAY Z-PATTERN",
    thumbnail: thumb25,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY Z-PATTERN
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Raleway:400,700" name="Raleway"></mj-font>
    <mj-attributes>
      <mj-all font-family="Raleway, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#f2f2f2">
    <mj-raw>
      <!-- 顶部横幅 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px">
          BLACK FRIDAY DEALS START NOW! 🔥
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Logo区域 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Z布局第一行 -->
    </mj-raw>
    <mj-section background-color="#000000">
      <mj-column width="60%">
        <mj-image alt="Hero" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591845834064_photo-1607082349566-187342175e2f_w_600.png"></mj-image>
      </mj-column>
      <mj-column padding="20px" width="40%">
        <mj-text align="left" color="#ffffff" font-size="36px" font-weight="bold">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="left" color="#ffffff" font-size="20px" padding-top="10px">
          UP TO 70% OFF
        </mj-text>
        <mj-button align="left" background-color="#ff0000" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Z布局第二行 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column padding="20px" width="40%">
        <mj-text align="right" color="#000000" font-size="30px" font-weight="bold">
          TECH DEALS
        </mj-text>
        <mj-text align="right" color="#ff0000" font-size="20px" padding-top="10px">
          SAVE 60%
        </mj-text>
        <mj-button align="right" background-color="#000000" color="#ffffff">
          EXPLORE
        </mj-button>
      </mj-column>
      <mj-column width="60%">
        <mj-image alt="Tech" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591846352765_photo-1468495244123-6c6c332eeece_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- Z布局第三行 -->
    </mj-raw>
    <mj-section background-color="#000000">
      <mj-column width="60%">
        <mj-image alt="Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591846622366_photo-1483985988355-763728e1935b_w_600.png"></mj-image>
      </mj-column>
      <mj-column padding="20px" width="40%">
        <mj-text align="left" color="#ffffff" font-size="30px" font-weight="bold">
          FASHION
        </mj-text>
        <mj-text align="left" color="#ff0000" font-size="20px" padding-top="10px">
          SAVE 50%
        </mj-text>
        <mj-button align="left" background-color="#ff0000" color="#ffffff">
          DISCOVER
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 优惠码区域 -->
    </mj-raw>
    <mj-section background-color="#ff0000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="bold">
          USE CODE: ZBLACK
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="18px" padding-top="10px">
          FOR EXTRA 15% OFF
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template26",
    title: "BLACK FRIDAY SPLIT DESIGN",
    thumbnail: thumb26,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY SPLIT DESIGN
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Bebas+Neue" name="Bebas Neue"></mj-font>
    <mj-attributes>
      <mj-all font-family="Bebas Neue, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#000000">
    <mj-raw>
      <!-- 顶部通知 -->
    </mj-raw>
    <mj-section background-color="#ff0000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="16px">
          24 HOURS ONLY - BIGGEST SALE OF THE YEAR
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 分割式标题区 -->
    </mj-raw>
    <mj-section>
      <mj-column background-color="#000000" padding="40px" width="70%">
        <mj-text align="right" color="#ffffff" font-size="80px">
          BLACK
        </mj-text>
        <mj-text align="right" color="#ff0000" font-size="30px">
          UP TO 70% OFF
        </mj-text>
      </mj-column>
      <mj-column background-color="#ff0000" padding="40px" width="30%">
        <mj-text align="left" color="#000000" font-size="80px">
          FRI
        </mj-text>
        <mj-text align="left" color="#000000" font-size="80px">
          DAY
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 不规则产品展示区 -->
    </mj-raw>
    <mj-section>
      <mj-column padding="2px" width="40%">
        <mj-image alt="Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847250767_photo-1523275335684-37898b6baf30_w_300.png"></mj-image>
      </mj-column>
      <mj-column background-color="#ffffff" padding="20px" width="60%">
        <mj-text align="left" color="#000000" font-size="36px">
          LUXURY WATCHES
        </mj-text>
        <mj-text align="left" color="#ff0000" font-size="24px" padding-top="10px">
          50% OFF
        </mj-text>
        <mj-button align="left" background-color="#000000" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 反向不规则展示 -->
    </mj-raw>
    <mj-section>
      <mj-column background-color="#ff0000" padding="20px" width="60%">
        <mj-text align="right" color="#ffffff" font-size="36px">
          HEADPHONES
        </mj-text>
        <mj-text align="right" color="#000000" font-size="24px" padding-top="10px">
          60% OFF
        </mj-text>
        <mj-button align="right" background-color="#000000" color="#ffffff">
          SHOP NOW
        </mj-button>
      </mj-column>
      <mj-column padding="2px" width="40%">
        <mj-image alt="Headphones" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847587268_photo-1505740420928-5e560c06d30e_w_300.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 三列不规则展示 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column padding="2px" width="33.33%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847895169_photo-1491553895911-0055eca6402d_w_200.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding="15px">
          FOOTWEAR
        </mj-text>
        <mj-text align="center" color="#ff0000" font-size="18px">
          40% OFF
        </mj-text>
      </mj-column>
      <mj-column background-color="#000000" padding="2px" width="33.33%">
        <mj-image alt="Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591848209670_photo-1483985988355-763728e1935b_w_200.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="24px" padding="15px">
          FASHION
        </mj-text>
        <mj-text align="center" color="#ff0000" font-size="18px">
          70% OFF
        </mj-text>
      </mj-column>
      <mj-column padding="2px" width="33.33%">
        <mj-image alt="Tech" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591848478171_photo-1526170375885-4d8ecf77b99f_w_200.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding="15px">
          TECH
        </mj-text>
        <mj-text align="center" color="#ff0000" font-size="18px">
          55% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 分割式优惠码区域 -->
    </mj-raw>
    <mj-section>
      <mj-column background-color="#000000" width="25%">
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          USE
        </mj-text>
      </mj-column>
      <mj-column background-color="#ff0000" width="50%">
        <mj-text align="center" color="#ffffff" font-size="30px" padding="20px">
          CODE: SPLIT20
        </mj-text>
      </mj-column>
      <mj-column background-color="#000000" width="25%">
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          NOW
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 配送信息 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="16px">
          FREE SHIPPING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="16px">
          30 DAYS RETURN
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#000000" font-size="16px">
          24/7 SUPPORT
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px" padding-top="20px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template27",
    title: "BLACK FRIDAY GALLERY",
    thumbnail: thumb27,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY GALLERY
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css?family=Playfair+Display:400,700" name="Playfair Display"></mj-font>
    <mj-attributes>
      <mj-all font-family="Playfair Display, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#1a1a1a">
    <mj-raw>
      <!-- 顶部通知 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="10px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px">
          BLACK FRIDAY PREVIEW - MEMBERS ONLY
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 主标题区 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="40px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="60px" font-weight="bold">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#666666" font-size="24px" padding-top="10px">
          CURATED COLLECTION
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 画廊第一行 -->
    </mj-raw>
    <mj-section>
      <mj-column padding="2px" width="33.33%">
        <mj-image alt="Watches" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847250767_photo-1523275335684-37898b6baf30_w_300.png"></mj-image>
      </mj-column>
      <mj-column padding="2px" width="33.33%">
        <mj-image alt="Headphones" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847587268_photo-1505740420928-5e560c06d30e_w_300.png"></mj-image>
      </mj-column>
      <mj-column padding="2px" width="33.33%">
        <mj-image alt="Footwear" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591849305672_photo-1491553895911-0055eca6402d_w_300.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 画廊描述行 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column padding="20px" width="33.33%">
        <mj-text align="center" color="#000000" font-size="20px">
          WATCHES
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          From $199
        </mj-text>
      </mj-column>
      <mj-column padding="20px" width="33.33%">
        <mj-text align="center" color="#000000" font-size="20px">
          AUDIO
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          From $99
        </mj-text>
      </mj-column>
      <mj-column padding="20px" width="33.33%">
        <mj-text align="center" color="#000000" font-size="20px">
          FOOTWEAR
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          From $79
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 大图展示 -->
    </mj-raw>
    <mj-section>
      <mj-column>
        <mj-image alt="Fashion" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591846622366_photo-1483985988355-763728e1935b_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 优惠信息 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="30px">
          UP TO 70% OFF
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="18px" padding-top="10px">
          USE CODE: GALLERY20
        </mj-text>
        <mj-button background-color="#ffffff" color="#000000" font-size="16px" padding-top="20px">
          EXPLORE THE COLLECTION
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 画廊第二行 -->
    </mj-raw>
    <mj-section>
      <mj-column padding="2px" width="50%">
        <mj-image alt="Tech" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591849806573_photo-1526170375885-4d8ecf77b99f_w_400.png"></mj-image>
      </mj-column>
      <mj-column padding="2px" width="50%">
        <mj-image alt="Laptops" href="#" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591850094674_photo-1544731612-de7f96afe55f_w_400.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 画廊描述第二行 -->
    </mj-raw>
    <mj-section background-color="#ffffff">
      <mj-column padding="20px" width="50%">
        <mj-text align="center" color="#000000" font-size="20px">
          TECH ACCESSORIES
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          50% OFF
        </mj-text>
      </mj-column>
      <mj-column padding="20px" width="50%">
        <mj-text align="center" color="#000000" font-size="20px">
          LAPTOPS
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px">
          40% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 倒计时区域 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          SALE ENDS IN
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="36px" font-weight="bold" padding-top="10px">
          24:00:00
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 页脚 -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px" padding-top="20px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template28",
    title: "BLACK FRIDAY MAGAZINE STYLE",
    thumbnail: thumb28,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY MAGAZINE STYLE
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;700" name="Bodoni Moda"></mj-font>
    <mj-attributes>
      <mj-all font-family="Bodoni Moda, Georgia, serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#ffffff">
    <mj-raw>
      <!-- 杂志式标题区 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="12px" letter-spacing="2px">
          THE STYLE EDIT
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="72px" font-weight="bold" padding="20px 0">
          NOIR
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px" font-style="italic">
          BLACK FRIDAY EDITION
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 主图区域 -->
    </mj-raw>
    <mj-section>
      <mj-column>
        <mj-image alt="Fashion Cover" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591850883275_photo-1483985988355-763728e1935b_w_600_h_800_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="12px" letter-spacing="1px" padding="10px">
          PHOTOGRAPHY BY STUDIO NOIR
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 杂志式内容区 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="40px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="36px" font-weight="bold">
          THE BLACK COLLECTION
        </mj-text>
        <mj-text align="center" color="#666666" font-size="16px" line-height="24px" padding="20px">
          Discover our curated selection of luxury pieces at unprecedented prices. For a limited time only.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 杂志式产品展示 -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column width="50%">
        <mj-image alt="Watches" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591851355976_photo-1523275335684-37898b6baf30_w_400.png"></mj-image>
        <mj-text align="left" color="#000000" font-size="20px" padding="10px">
          01. TIMEPIECES
        </mj-text>
        <mj-text align="left" color="#666666" font-size="14px" padding="0 10px">
          Classic designs with modern sophistication
        </mj-text>
        <mj-text align="left" color="#000000" font-size="16px" font-weight="bold" padding="10px">
          UP TO 60% OFF
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Audio" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591851627977_photo-1505740420928-5e560c06d30e_w_400.png"></mj-image>
        <mj-text align="left" color="#000000" font-size="20px" padding="10px">
          02. AUDIO
        </mj-text>
        <mj-text align="left" color="#666666" font-size="14px" padding="0 10px">
          Premium sound for the discerning listener
        </mj-text>
        <mj-text align="left" color="#000000" font-size="16px" font-weight="bold" padding="10px">
          UP TO 50% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 优雅分隔线 -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column>
        <mj-divider border-color="#000000" border-width="1px"></mj-divider>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 特别企划区 -->
    </mj-raw>
    <mj-section background-color="#f8f8f8" padding="40px">
      <mj-column width="40%">
        <mj-text align="right" color="#000000" font-size="24px" font-weight="bold">
          EDITOR'S PICK
        </mj-text>
        <mj-text align="right" color="#666666" font-size="16px" padding-top="10px">
          Carefully selected pieces for the modern connoisseur
        </mj-text>
      </mj-column>
      <mj-column width="60%">
        <mj-image alt="Editor's Pick" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591851922378_photo-1491553895911-0055eca6402d_w_500.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 优惠码区域 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="12px" letter-spacing="2px">
          EXCLUSIVE OFFER
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px" font-style="italic" padding="20px">
          Use Code: NOIRMAG
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="16px">
          For an additional 20% off
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 杂志式分类导航 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="30px">
      <mj-column width="25%">
        <mj-text align="center" color="#000000" font-size="14px" letter-spacing="1px">
          WOMEN
        </mj-text>
      </mj-column>
      <mj-column width="25%">
        <mj-text align="center" color="#000000" font-size="14px" letter-spacing="1px">
          MEN
        </mj-text>
      </mj-column>
      <mj-column width="25%">
        <mj-text align="center" color="#000000" font-size="14px" letter-spacing="1px">
          ACCESSORIES
        </mj-text>
      </mj-column>
      <mj-column width="25%">
        <mj-text align="center" color="#000000" font-size="14px" letter-spacing="1px">
          BEAUTY
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 杂志式页脚 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="bold">
          THE STYLE EDIT
        </mj-text>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px" letter-spacing="1px" padding-top="20px">
          © 2024 Your Luxury Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template29",
    title: "BLACK FRIDAY MINIMALIST",
    thumbnail: thumb29,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY MINIMALIST
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500" name="DM Sans"></mj-font>
    <mj-attributes>
      <mj-all font-family="DM Sans, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#ffffff">
    <mj-raw>
      <!-- 极简标题区 -->
    </mj-raw>
    <mj-section background-color="#f8f8f8" padding="100px 0">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="14px" letter-spacing="2px">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#000000" font-size="40px" padding="20px 0">
          Less is more.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 简约产品展示 -->
    </mj-raw>
    <mj-section padding="40px">
      <mj-column>
        <mj-image alt="Product" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591852706379_photo-1523275335684-37898b6baf30_w_600.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="12px" letter-spacing="1px" padding="20px">
          01 / TIMEPIECES
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 简约优惠信息 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px" letter-spacing="2px">
          50% OFF ALL ITEMS
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 极简产品网格 -->
    </mj-raw>
    <mj-section padding="2px">
      <mj-column width="50%">
        <mj-image alt="Audio" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591847587268_photo-1505740420928-5e560c06d30e_w_300.png"></mj-image>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Footwear" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591849305672_photo-1491553895911-0055eca6402d_w_300.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 简约页脚 -->
    </mj-raw>
    <mj-section padding="40px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="12px" letter-spacing="1px">
          © 2024
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template30",
    title: "BLACK FRIDAY VINTAGE",
    thumbnail: thumb30,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY VINTAGE
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Old+Standard+TT:wght@400;700" name="Old Standard TT"></mj-font>
    <mj-attributes>
      <mj-all font-family="Old Standard TT, Georgia, serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
    <mj-style>
      .vintage-border {
      border: 2px solid #2b2b2b;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f4e4bc">
    <mj-raw>
      <!-- 复古标题区 -->
    </mj-raw>
    <mj-section background-color="#2b2b2b" padding="40px">
      <mj-column>
        <mj-text align="center" color="#f4e4bc" font-size="60px" font-weight="bold">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#f4e4bc" font-size="20px" font-style="italic">
          EST. 2024
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古装饰元素 - 使用通用的分隔线替代装饰图片 -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column>
        <mj-divider border-color="#2b2b2b" border-style="solid" border-width="2px" width="100px"></mj-divider>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古产品展示 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Vintage Watch" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591853997680_photo-1539874754764-5a96559165b0_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2b2b2b" font-size="24px" padding="20px">
          TIMEPIECES
        </mj-text>
        <mj-text align="center" color="#2b2b2b" font-size="16px">
          Since 1920
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Vintage Audio" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591854644681_photo-1487180144351-b8472da7d491_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2b2b2b" font-size="24px" padding="20px">
          PHONOGRAPHS
        </mj-text>
        <mj-text align="center" color="#2b2b2b" font-size="16px">
          Classic Collection
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古风格产品类别 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="Vintage Cameras" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591854926982_photo-1464820453369-31d2c0b651af_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2b2b2b" font-size="18px" padding="10px">
          CAMERAS
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Vintage Furniture" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591855196583_photo-1519340241574-2cec6aef0c01_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2b2b2b" font-size="18px" padding="10px">
          FURNITURE
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Vintage Accessories" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591855503584_photo-1492707892479-7bc8d5a4ee93_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2b2b2b" font-size="18px" padding="10px">
          ACCESSORIES
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古优惠信息 -->
    </mj-raw>
    <mj-section background-color="#2b2b2b" padding="40px">
      <mj-column>
        <mj-text align="center" color="#f4e4bc" font-size="30px">
          SAVE UP TO 70%
        </mj-text>
        <mj-text align="center" color="#f4e4bc" font-size="18px" padding-top="10px">
          Use Code: VINTAGE24
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古风格服务承诺 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="30px">
      <mj-column width="33.33%">
        <mj-text align="center" color="#2b2b2b" font-size="16px">
          AUTHENTIC PIECES
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#2b2b2b" font-size="16px">
          WORLDWIDE SHIPPING
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-text align="center" color="#2b2b2b" font-size="16px">
          QUALITY GUARANTEED
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 复古页脚 -->
    </mj-raw>
    <mj-section padding="40px">
      <mj-column>
        <mj-text align="center" color="#2b2b2b" font-size="16px" font-style="italic">
          Established in the tradition of excellence
        </mj-text>
        <mj-divider border-color="#2b2b2b" border-style="solid" border-width="1px" padding="20px 0" width="50px"></mj-divider>
        <mj-text align="center" color="#2b2b2b" font-size="14px">
          © 2024 Your Vintage Brand
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template31",
    title: "BLACK FRIDAY ARTSY",
    thumbnail: thumb31,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY ARTSY
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Caveat:wght@400;700" name="Caveat"></mj-font>
    <mj-font href="https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700" name="Amatic SC"></mj-font>
    <mj-attributes>
      <mj-text font-family="Caveat, cursive"></mj-text>
      <mj-button font-family="Amatic SC, cursive"></mj-button>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#faf7f2">
    <mj-raw>
      <!-- 艺术标题区 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-family="Amatic SC" font-size="80px">
          Black Friday
        </mj-text>
        <mj-text align="center" color="#ffffff" font-family="Caveat" font-size="30px">
          Art & Design Sale
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 手绘风格主图 -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column>
        <mj-image alt="Artsy" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591856176685_photo-1460661419201-fd4cecdf8a8b_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 艺术品类别 -->
    </mj-raw>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="Art Supplies" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591856581286_photo-1513364776144-60967b0f800f_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="26px" padding="10px">
          Art Supplies
        </mj-text>
        <mj-text align="center" color="#666666" font-size="20px">
          50% Off
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Canvas" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591856862687_photo-1459908676235-d5f02a50184b_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="26px" padding="10px">
          Canvas
        </mj-text>
        <mj-text align="center" color="#666666" font-size="20px">
          40% Off
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Brushes" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591857104588_photo-1452860606245-08befc0ff44b_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="26px" padding="10px">
          Brushes
        </mj-text>
        <mj-text align="center" color="#666666" font-size="20px">
          60% Off
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 手绘风格优惠码 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="40px">
          Use Code: ARTSY
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="24px" padding-top="10px">
          for extra 20% off
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 艺术家精选 -->
    </mj-raw>
    <mj-section padding="20px">
      <mj-column width="50%">
        <mj-image alt="Artist Pick 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591857380489_photo-1513364776144-60967b0f800f_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding="10px">
          Watercolors
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Artist Pick 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591857685590_photo-1460661419201-fd4cecdf8a8b_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#000000" font-size="24px" padding="10px">
          Acrylics
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 艺术风格页脚 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          Create Something Beautiful
        </mj-text>
        <mj-social font-size="15px" icon-color="#ffffff" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
          <mj-social-element href="#" name="youtube"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="16px" padding-top="20px">
          © 2024 Artist's Corner
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template32",
    title: "BLACK FRIDAY INDUSTRIAL",
    thumbnail: thumb32,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      BLACK FRIDAY INDUSTRIAL
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;700" name="Roboto Mono"></mj-font>
    <mj-attributes>
      <mj-all font-family="Roboto Mono, monospace"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#1a1a1a">
    <mj-raw>
      <!-- 工业风格标题 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ff4d4d" font-size="14px" letter-spacing="2px">
          INDUSTRIAL SERIES
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="48px" font-weight="bold" padding="20px 0">
          BLACK FRIDAY
        </mj-text>
        <mj-text align="center" color="#999999" font-size="18px">
          ENGINEERED FOR PERFORMANCE
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 工业风格主图 -->
    </mj-raw>
    <mj-section>
      <mj-column>
        <mj-image alt="Industrial" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591858424691_photo-1581091226825-a6a2a5aee158_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 工业产品展示 -->
    </mj-raw>
    <mj-section background-color="#262626" padding="20px">
      <mj-column width="50%">
        <mj-image alt="Tools" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591858805992_photo-1572981779307-38b8cabb2407_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="left" color="#ffffff" font-size="20px" padding="20px">
          POWER TOOLS
        </mj-text>
        <mj-text align="left" color="#ff4d4d" font-size="16px">
          50% OFF
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Equipment" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591859045593_photo-1581092580497-e0d23cbdf1dc_w_400_h_300_fit_crop.png"></mj-image>
        <mj-text align="left" color="#ffffff" font-size="20px" padding="20px">
          EQUIPMENT
        </mj-text>
        <mj-text align="left" color="#ff4d4d" font-size="16px">
          60% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 工业风格优惠码 -->
    </mj-raw>
    <mj-section background-color="#ff4d4d" padding="30px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="24px" font-weight="bold">
          USE CODE: INDUSTRIAL24
        </mj-text>
        <mj-text align="center" color="#000000" font-size="16px" padding-top="10px">
          FOR ADDITIONAL 20% OFF
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 产品规格展示 -->
    </mj-raw>
    <mj-section background-color="#262626" padding="20px">
      <mj-column width="33.33%">
        <mj-image alt="Machinery" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591859311194_photo-1572981779307-38b8cabb2407_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="16px" padding="10px">
          MACHINERY
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px">
          HEAVY DUTY
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Safety" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591859596995_photo-1581092580497-e0d23cbdf1dc_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="16px" padding="10px">
          SAFETY GEAR
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px">
          CERTIFIED
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Workshop" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173591859822996_photo-1581091226825-a6a2a5aee158_w_300_h_200_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="16px" padding="10px">
          WORKSHOP
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px">
          EQUIPMENT
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 技术规格 -->
    </mj-raw>
    <mj-section background-color="#000000" padding="30px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="16px" letter-spacing="2px">
          TECHNICAL SPECIFICATIONS
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px" padding-top="10px">
          • INDUSTRIAL GRADE •
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px">
          • PROFESSIONAL SERIES •
        </mj-text>
        <mj-text align="center" color="#999999" font-size="14px">
          • LIFETIME WARRANTY •
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-raw>
      <!-- 工业风格页脚 -->
    </mj-raw>
    <mj-section background-color="#1a1a1a" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px">
          ENGINEERED WITH PRECISION
        </mj-text>
        <mj-text align="center" color="#999999" font-size="12px" padding-top="20px">
          © 2024 INDUSTRIAL TOOLS & CO.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template33",
    title: "Next Gen Tech Launch",
    thumbnail: thumb33,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Next Gen Tech Launch
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600&display=swap" name="Space Grotesk"></mj-font>
    <mj-attributes>
      <mj-all font-family="Space Grotesk, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#0A0A0A">
    <mj-section background-color="#00FF94" padding="12px">
      <mj-column>
        <mj-text align="center" color="#000000" font-size="16px" font-weight="600">
          FUTURE IS NOW | PRE-ORDER AVAILABLE
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#0A0A0A" padding="40px">
      <mj-column>
        <mj-text align="center" color="#00FF94" font-size="14px" letter-spacing="2px">
          INTRODUCING
        </mj-text>
        <mj-text align="center" color="#ffffff" font-size="48px" font-weight="600" padding="20px">
          NEXT GEN TECH
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#0A0A0A">
      <mj-column>
        <mj-image alt="Tech Product" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612366321_photo-1526738549149-8e07eca6c147_w_800_h_500_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#0A0A0A" padding="40px 0px">
      <mj-column width="50%">
        <mj-image alt="Feature 1" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612405852_photo-1550009158-9ebf69173e03_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          AI Powered
        </mj-text>
        <mj-text align="center" color="#00FF94" font-size="16px">
          Next-Gen Intelligence
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Feature 2" padding="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612430173_photo-1535223289827-42f1e9919769_w_400_h_400_fit_crop.png"></mj-image>
        <mj-text align="center" color="#ffffff" font-size="24px" padding="20px">
          8K Display
        </mj-text>
        <mj-text align="center" color="#00FF94" font-size="16px">
          Ultra Clear Vision
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#111111" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px">
          PRE-ORDER NOW
        </mj-text>
        <mj-text align="center" color="#00FF94" font-size="36px" font-weight="bold" padding="20px">
          SAVE 30%
        </mj-text>
        <mj-button background-color="#00FF94" color="#000000" font-size="16px" font-weight="600">
          ORDER NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#0A0A0A" padding="30px">
      <mj-column width="33.33%">
        <mj-image alt="Tech 1" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612452544_photo-1451187580459-43490279c0fa_w_300_h_200_fit_crop.png"></mj-image>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Tech 2" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612475605_photo-1485827404703-89b55fcc595e_w_300_h_200_fit_crop.png"></mj-image>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Tech 3" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612497986_photo-1480694313141-fce5e697ee25_w_300_h_200_fit_crop.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#111111" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-color="#00FF94" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="twitter"></mj-social-element>
          <mj-social-element href="#" name="youtube"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#ffffff" font-size="12px" padding="10px">
          © 2024 Tech Innovation. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template34",
    title: "Spring Collection 2024",
    thumbnail: thumb34,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Spring Collection 2024
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600&display=swap" name="Cormorant Garamond"></mj-font>
    <mj-attributes>
      <mj-all font-family="Cormorant Garamond, Georgia, serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
  </mj-head>
  <mj-body background-color="#F5F5F5">
    <mj-section background-color="#E8F3D6" padding="10px">
      <mj-column>
        <mj-text align="center" color="#2C3639" font-size="16px" font-weight="600">
          NEW COLLECTION PREVIEW - FREE SHIPPING ON ALL ORDERS
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-image alt="Logo" href="https://www.easyemail.pro/?utm_source=email_template" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hwm526rq8_e9s0ynhimam_image.png" width="150px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="40px">
      <mj-column>
        <mj-text align="center" color="#2C3639" font-size="60px" font-weight="600">
          Spring Collection
        </mj-text>
        <mj-text align="center" color="#7D9D9C" font-size="24px" padding-top="10px">
          Embrace the New Season
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding="20px">
      <mj-column width="50%">
        <mj-image alt="Spring Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612573817_photo-1515372039744-b8f02a3ae446_w_500_h_700_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2C3639" font-size="24px" padding="20px">
          Women's Collection
        </mj-text>
      </mj-column>
      <mj-column width="50%">
        <mj-image alt="Men's Fashion" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612616358_photo-1488161628813-04466f872be2_w_500_h_700_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2C3639" font-size="24px" padding="20px">
          Men's Collection
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="40px">
      <mj-column width="33.33%">
        <mj-image alt="Accessories" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/17362612640399_photo-1485230895905-ec40ba36b9bc_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2C3639" font-size="20px" padding="10px">
          Accessories
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Shoes" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626126634810_photo-1503342217505-b0a15ec3261c_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2C3639" font-size="20px" padding="10px">
          Footwear
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Bags" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626126867411_photo-1492707892479-7bc8d5a4ee93_w_300_h_300_fit_crop.png"></mj-image>
        <mj-text align="center" color="#2C3639" font-size="20px" padding="10px">
          Bags
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#E8F3D6" padding="30px">
      <mj-column>
        <mj-text align="center" color="#2C3639" font-size="24px" font-weight="600">
          EARLY ACCESS OFFER
        </mj-text>
        <mj-text align="center" color="#2C3639" font-size="18px" padding="10px">
          Get 20% Off Your First Purchase
        </mj-text>
        <mj-button background-color="#2C3639" color="#ffffff" font-size="16px" font-weight="600" padding="20px">
          SHOP NOW
        </mj-button>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="20px">
      <mj-column>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element href="#" name="facebook"></mj-social-element>
          <mj-social-element href="#" name="instagram"></mj-social-element>
          <mj-social-element href="#" name="pinterest"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#2C3639" font-size="12px" padding="10px">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template35",
    title: "Exclusive 24-Hour Sale",
    thumbnail: thumb35,
    mjml: `<mjml>
  <mj-head>
    <mj-title>
      Exclusive 24-Hour Sale
    </mj-title>
    <mj-font href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap" name="DM Sans"></mj-font>
    <mj-attributes>
      <mj-all font-family="DM Sans, Arial, sans-serif"></mj-all>
      <mj-text padding="0"></mj-text>
      <mj-section padding="0"></mj-section>
      <mj-image padding="0"></mj-image>
    </mj-attributes>
    <mj-style>
      .gradient-text {
        background: linear-gradient(90deg, #FF6B6B 0%, #FFB86C 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#FAFAFA">
    <mj-section background-color="#111111" padding="12px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="14px" letter-spacing="1px">
          24 HOURS ONLY - EXCLUSIVE DEALS INSIDE
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="30px">
      <mj-column>
        <mj-image alt="Logo" src="https://via.placeholder.com/150x50" width="120px"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="0 30px 40px">
      <mj-column>
        <mj-text align="center" color="#111111" font-size="42px" font-weight="700" line-height="1.2">
          24-Hour Flash Sale
        </mj-text>
        <mj-text align="center" color="#FF6B6B" font-size="24px" font-weight="500" padding="20px 0">
          Up to 60% Off Premium Items
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding="0">
      <mj-column>
        <mj-image alt="Hero" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626134403212_photo-1441984904996-e0b6ba687e04_w_600.png"></mj-image>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="40px 20px">
      <mj-column width="33.33%">
        <mj-image alt="Premium Watch" padding="0 10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626135116713_photo-1523275335684-37898b6baf30.png"></mj-image>
        <mj-text align="center" font-size="18px" padding="15px 0 5px">
          Premium Watch
        </mj-text>
        <mj-text align="center" color="#FF6B6B" font-size="16px" font-weight="700">
          <strike style="color: #999">$299</strike> $149
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Leather Bag" padding="0 10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626135725814_photo-1491637639811-60e2756cc1c7_w_600.png"></mj-image>
        <mj-text align="center" font-size="18px" padding="15px 0 5px">
          Leather Bag
        </mj-text>
        <mj-text align="center" color="#FF6B6B" font-size="16px" font-weight="700">
          <strike style="color: #999">$199</strike> $89
        </mj-text>
      </mj-column>
      <mj-column width="33.33%">
        <mj-image alt="Sneakers" padding="0 10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/173626136207315_photo-1595950653106-6c9ebd614d3a.png"></mj-image>
        <mj-text align="center" font-size="18px" padding="15px 0 5px">
          Limited Sneakers
        </mj-text>
        <mj-text align="center" color="#FF6B6B" font-size="16px" font-weight="700">
          <strike style="color: #999">$159</strike> $79
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#111111" padding="40px">
      <mj-column>
        <mj-text align="center" color="#ffffff" font-size="24px" font-weight="700">
          Use Code: FLASH60
        </mj-text>
        <mj-button background-color="#FF6B6B" border-radius="4px" color="#ffffff" font-size="16px" font-weight="700" href="#" padding="25px">
          SHOP NOW
        </mj-button>
        <mj-text align="center" color="#999999" font-size="14px" padding-top="20px">
          Offer ends in 24 hours. While stocks last.
        </mj-text>
      </mj-column>
    </mj-section>
    <mj-section background-color="#ffffff" padding="40px 20px">
      <mj-column>
        <mj-text align="center" font-size="18px" font-weight="700" padding-bottom="20px">
          Follow Us
        </mj-text>
        <mj-social font-size="15px" icon-size="30px" mode="horizontal">
          <mj-social-element background-color="#111111" href="#" name="instagram"></mj-social-element>
          <mj-social-element background-color="#111111" href="#" name="facebook"></mj-social-element>
          <mj-social-element background-color="#111111" href="#" name="twitter"></mj-social-element>
        </mj-social>
        <mj-text align="center" color="#999999" font-size="12px" padding="20px 0 0">
          © 2024 Your Brand. All rights reserved.
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template36",
    title: "Template 36",
    thumbnail: thumb36,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
    <mj-font name="Benton Sans" href="https://www.masters.com/assets/fonts/bentonsans/BentonSans-Book.woff2" />
  </mj-head>
  <mj-body width="660px" background-color="#EEEEEE" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#EEEEEE"><mj-column width="50%"><mj-text color="#333333" font-family="'Benton Sans', Tahoma, sans-serif" font-size="12px" line-height="19px" padding="10px 25px" padding-right="10px" padding-left="10px">Your Daily Briefing from Augusta National</mj-text></mj-column><mj-column width="50%"><mj-text align="right" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="12px" line-height="19px" padding="10px 25px" padding-right="10px" padding-left="10px"><span><a href="#">View in browser</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/j7pqm2yl_welcomeback.jpg" alt="Welcome Back" width="660px" href="https://www.masters.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">So begins a week full of anticipation. Players arrive with high hopes and Green Jacket dreams. By Sunday, someone's name will be etched into Masters history. But before glory can be claimed, there's work to be done. Welcome to the 90th Masters Tournament.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="30px" padding-bottom="10px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="24px" line-height="31px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="normal">Featured</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#FFFFFF"><mj-column padding-bottom="10px" width="50%"><mj-image padding="10px 25px" padding-right="10px" padding-left="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/catwh95i_1540584_mondaytrailer-040626.png" alt="Monday at the Masters" width="290px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIObX6A0o_JfwFQbrD2cCHufvhdN341Sihz_flN752ZXQKOk6mlHkJbGi"></mj-image></mj-column><mj-column padding-bottom="10px" width="50%"><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="20px" line-height="31px" padding="10px 25px" padding-top="5px" padding-right="10px" padding-bottom="0px" padding-left="10px"><span><a href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIObX6A0o_JfwFQbrD2cCHufvhdN341Sihz_flN752ZXQKOk6mlHkJbGi">Monday at the Masters</a></span></mj-text><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="10px" padding-left="10px">Today is the day we've been waiting for. Welcome back to this annual rite of spring. It is, at long last, Monday at the Masters.</mj-text><mj-button align="left" background-color="#F7DF01" border-radius="0px" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" font-weight="bold" letter-spacing="1px" line-height="20px" inner-padding="8px 10px 8px 10px" padding="10px 25px" padding-right="10px" padding-left="10px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIObX6A0o_JfwFQbrD2cCHufvhdN341Sihz_flN752ZXQKOk6mlHkJbGi">WATCH TRAILER</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-divider border-width="2px" border-color="#EEEEEE" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#FFFFFF"><mj-column padding-bottom="10px" width="50%"><mj-image padding="10px 25px" padding-right="10px" padding-left="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5o1ivylt_1540567_rangetracker-040626.png" alt="Range Tracker" width="290px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBINnF6A0o_JfwFYVaJji445OUYK_2B02Bk7yz9TNKNrSDAO7l0zB_J7gy"></mj-image></mj-column><mj-column padding-bottom="10px" width="50%"><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="20px" line-height="31px" padding="10px 25px" padding-top="5px" padding-right="10px" padding-bottom="0px" padding-left="10px"><span><a href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBINnF6A0o_JfwFYVaJji445OUYK_2B02Bk7yz9TNKNrSDAO7l0zB_J7gy">Range Tracker</a></span></mj-text><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="10px" padding-left="10px">Follow every shot from the Tournament Practice Area today as players fine-tune their game for the week ahead.</mj-text><mj-button align="left" background-color="#F7DF01" border-radius="0px" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" font-weight="bold" letter-spacing="1px" line-height="20px" inner-padding="8px 14px 8px 14px" padding="10px 25px" padding-right="10px" padding-left="10px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBINnF6A0o_JfwFYVaJji445OUYK_2B02Bk7yz9TNKNrSDAO7l0zB_J7gy">VIEW TRACKER</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-divider border-width="2px" border-color="#EEEEEE" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#FFFFFF"><mj-column padding-bottom="10px" width="50%"><mj-image padding="10px 25px" padding-right="10px" padding-left="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/ef1rh4lg_1540575_earlyarrivals-040526.png" alt="A Sunday Stroll" width="290px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIPLH6A0o_JfwFaqJfoCWEFN_0IBqY-Ma888CuxrqtMctE4eMRQY0uy0n"></mj-image></mj-column><mj-column padding-bottom="10px" width="50%"><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="20px" line-height="31px" padding="10px 25px" padding-top="5px" padding-right="10px" padding-bottom="0px" padding-left="10px"><span><a href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIPLH6A0o_JfwFaqJfoCWEFN_0IBqY-Ma888CuxrqtMctE4eMRQY0uy0n">A Sunday Stroll</a></span></mj-text><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="10px" padding-left="10px">After the Drive, Chip and Putt National Finals, many of the game's biggest names got in some early work at Augusta National.</mj-text><mj-button align="left" background-color="#F7DF01" border-radius="0px" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" font-weight="bold" letter-spacing="1px" line-height="20px" inner-padding="8px 15px 8px 15px" padding="10px 25px" padding-right="10px" padding-left="10px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIPLH6A0o_JfwFaqJfoCWEFN_0IBqY-Ma888CuxrqtMctE4eMRQY0uy0n">VIEW GALLERY</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-divider border-width="2px" border-color="#EEEEEE" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#FFFFFF"><mj-column padding-bottom="10px" width="50%"><mj-image padding="10px 25px" padding-right="10px" padding-left="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/w2ljdtgo_1540582_playingthepatch-040526.png" alt="Playing The Patch" width="290px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIJDN6A0o_JfwFepenZCPWQXNoge9eZJZfdMVyJVCeDdeeyRlZDfGokOi"></mj-image></mj-column><mj-column padding-bottom="10px" width="50%"><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="20px" line-height="31px" padding="10px 25px" padding-top="5px" padding-right="10px" padding-bottom="0px" padding-left="10px"><span><a href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIJDN6A0o_JfwFepenZCPWQXNoge9eZJZfdMVyJVCeDdeeyRlZDfGokOi">Playing The Patch</a></span></mj-text><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="10px" padding-left="10px">For nearly a century, Augusta Municipal Golf Course – more affectionately known as The Patch – has been an institution. It opens to the public once again on April 15.</mj-text><mj-button align="left" background-color="#F7DF01" border-radius="0px" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" font-weight="bold" letter-spacing="1px" line-height="20px" inner-padding="8px 15px 8px 15px" padding="10px 25px" padding-right="10px" padding-left="10px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIJDN6A0o_JfwFepenZCPWQXNoge9eZJZfdMVyJVCeDdeeyRlZDfGokOi">READ ARTICLE</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-divider border-width="2px" border-color="#EEEEEE" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#FFFFFF"><mj-column padding-bottom="10px" width="50%"><mj-image padding="10px 25px" padding-right="10px" padding-left="10px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/6twsaofq_1540581_purehappiness-040526.png" alt="Pure Happiness on Display" width="290px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBILbJ6A0o_JfwFWY9AIcC_KBx2cyDvVTODtjQBrYVnMHsjczaGcdgmJJL"></mj-image></mj-column><mj-column padding-bottom="10px" width="50%"><mj-text color="#006744" font-family="tiempos-light, Georgia, sans-serif" font-size="20px" line-height="31px" padding="10px 25px" padding-top="5px" padding-right="10px" padding-bottom="0px" padding-left="10px"><span><a href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBILbJ6A0o_JfwFWY9AIcC_KBx2cyDvVTODtjQBrYVnMHsjczaGcdgmJJL">Pure Happiness on Display</a></span></mj-text><mj-text color="#25282A" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="10px" padding-left="10px">Each year, the participants in the Drive, Chip and Putt National Finals remind us what pure happiness looks like.</mj-text><mj-button align="left" background-color="#F7DF01" border-radius="0px" color="#006744" font-family="'Benton Sans', Tahoma, sans-serif" font-size="14px" font-weight="bold" letter-spacing="1px" line-height="20px" inner-padding="8px 16px 8px 16px" padding="10px 25px" padding-right="10px" padding-left="10px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBILbJ6A0o_JfwFWY9AIcC_KBx2cyDvVTODtjQBrYVnMHsjczaGcdgmJJL">WATCH RECAP</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column><mj-spacer height="10px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="25px" padding-right="10px" padding-bottom="10px" padding-left="10px" background-color="#1C4932"><mj-column><mj-social border-radius="0px" font-family="Arial, sans-serif" icon-size="24px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIObB6A0o_JfwFSId-NXxXDkZxlBL87gwq0BSDQ0ubgW92y7Z8ZMisBh7" alt="Facebook" background-color="#3b5998" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/cxhzkclel5ojn_dzo1o7v_facebook.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIOfB6A0o_JfwFU9-dsx38lJp8ArLXQ89m1RwH4aGVAx8lbkplbhlsH3M" alt="Instagram" background-color="#3f729b" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yyeuinjdwnclhwonzm04p_instagram.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIOnB6A0o_JfwFXpot2lxf9o9lFxXxQK-NKEIvtUW_AD4LyF9l0Ld3VLB" alt="Twitter" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/vjjjm0-8wv5-oumveqyna_twitter-x.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.masters.com/c/AQjHkhMQ5ck3GPLlyMYBIOrB6A0o_JfwFcVizRj5CxEtkz5qkTZP1s_TwUvNRFIwRgn8aLktBq7T" alt="YouTube" background-color="#EB3323" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/j5wv-vgx4tse62wzjde4q_youtube.png"></mj-social-element></mj-social></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="10px" padding-bottom="0px" padding-left="10px" background-color="#1C4932"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Benton Sans', Tahoma, sans-serif" font-size="12px" line-height="22px" padding="10px 25px" padding-right="10px" padding-left="10px">Copyright © 2026 The Masters, All rights reserved.&nbsp;<br /> You are receiving this email because you previously signed up for information from the Masters.<br />If you no longer wish to receive newsletter emails from us,&nbsp;<span><a href="{{unsubscribeUrl}}">unsubscribe</a></span> here.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#1C4932"><mj-column><mj-divider border-width="1px" border-color="#FFFFFF" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="10px" padding-bottom="0px" padding-left="10px" background-color="#1C4932"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Benton Sans', Tahoma, sans-serif" font-size="12px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Augusta National Golf Club, 2604 Washington Rd, Augusta, GA 30904</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="10px" padding-left="10px" background-color="#1C4932"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/qq7uw68x_1540518_partner_2026_all_040426.gif" alt="Official Partners" width="249px"></mj-image></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template37",
    title: "Template 37",
    thumbnail: thumb37,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
    <mj-font name="Figtree" href="https://fonts.googleapis.com/css2?family=Figtree:wght@400;600;700&display=swap" />
  </mj-head>
  <mj-body width="600px" background-color="#F2F5FF" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="17px" padding-right="15px" padding-bottom="17px" padding-left="15px" background-color="#FFFFFF"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/s2sm8h3k_App-Icon.png" alt="Calm Logo" width="47px" href="https://www.calm.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-size="cover" background-position="center top" padding="20px 0" padding-top="30px" padding-right="20px" padding-bottom="130px" padding-left="20px" background-color="#1D3358" background-url="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/daifmu7q_Hero-BG4.png"><mj-column><mj-text align="center" color="#FFFFFF" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="11px" line-height="16px" letter-spacing="1.7px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" font-weight="600"><span style="background-color:#141473;border:1px solid #FFFFFF;border-radius:50px;padding:5px 20px;display:inline-block;text-transform:uppercase;">Exclusive Partnership Offers</span></mj-text><mj-text align="center" color="#FFFFFF" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="42px" line-height="46px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px" font-weight="400">More Ways to Access Calm</mj-text><mj-text align="center" color="#FFFFFF" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="400">Unlock exclusive offers and partner experiences designed to support your mindfulness journey.</mj-text></mj-column></mj-section><mj-wrapper padding="20px 0px" padding-top="0px" padding-right="15px" padding-bottom="30px" padding-left="15px" background-color="#1D3358"><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="7px" padding-bottom="7px"><mj-column><mj-spacer height="1px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="10px" padding-bottom="10px" padding-left="10px" background-color="#FFFFFF" border-radius="10px"><mj-column vertical-align="middle" width="35%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/id52mctb_Disney.png" alt="Calm and Disney+ Perks" width="175px" border-radius="8px" href="https://www.calm.com/disney" fluid-on-mobile="true"></mj-image></mj-column><mj-column vertical-align="middle" padding-left="10px" width="65%"><mj-text color="#333333" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="600">Calm and Disney+ Perks</mj-text><mj-text color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">Disney+ subscribers can redeem a 6-month free trial to Calm Premium¹. Enjoy the full Calm library, including Sleep Stories, meditations, and soundscapes from your favorite Disney Princesses.</mj-text><mj-text color="#555BE4" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.calm.com/disney">Redeem Now →</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="7px" padding-bottom="7px"><mj-column><mj-spacer height="1px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="10px" padding-bottom="10px" padding-left="10px" background-color="#FFFFFF" border-radius="10px"><mj-column vertical-align="middle" width="35%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bz0cdjd4_Sweat.png" alt="Calm + Sweat" width="175px" border-radius="8px" href="https://www.calm.com/sweat" fluid-on-mobile="true"></mj-image></mj-column><mj-column vertical-align="middle" padding-left="10px" width="65%"><mj-text color="#333333" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="600">Calm + Sweat: Calm mind. Strong body.</mj-text><mj-text color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">Sweat members can get a 6-month free trial to Calm Premium². Pause and take a breath with Calm's library of Sleep Stories, meditations, and soundscapes.</mj-text><mj-text color="#555BE4" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.calm.com/sweat">Redeem Now →</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="7px" padding-bottom="7px"><mj-column><mj-spacer height="1px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="10px" padding-right="10px" padding-bottom="10px" padding-left="10px" background-color="#FFFFFF" border-radius="10px"><mj-column vertical-align="middle" width="35%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/cgr76jni_Delta.png" alt="Calm for Delta Business Travelers" width="175px" border-radius="8px" href="https://www.calm.com/delta" fluid-on-mobile="true"></mj-image></mj-column><mj-column vertical-align="middle" padding-left="10px" width="65%"><mj-text color="#333333" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="600">Calm for Delta Business Travelers</mj-text><mj-text color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">Delta Business Travelers can get a 1-month free trial to Calm Premium³ plus an exclusive 50% off for the first 12 months. Pause and take a breath with Calm's library.</mj-text><mj-text color="#555BE4" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.calm.com/delta">Redeem Now →</a></span></mj-text></mj-column></mj-section></mj-wrapper><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="30px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-divider border-width="1px" border-color="#D8D8D8" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider><mj-text align="center" color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="10px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">¹ Disney+ offer valid for new Calm users.&nbsp;<span><a href="#">Terms and conditions apply</a></span>.</mj-text><mj-text align="center" color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="10px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">² Sweat offer valid for Sweat members.&nbsp;<span><a href="https://sweat.com/terms-of-use">Terms and conditions apply</a></span>.</mj-text><mj-text align="center" color="#717171" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="10px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" font-weight="400">³ Delta offer valid for Business Travelers.&nbsp;<span><a href="#">Terms & Conditions Apply</a></span>.</mj-text><mj-divider border-width="1px" border-color="#D8D8D8" width="375px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-left="20px" background-color="#FFFFFF"><mj-column><mj-social font-family="Arial, sans-serif" font-size="0px" icon-size="53px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" icon-height="49px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.instagram.com/calm" alt="Instagram" icon-size="53px" icon-height="49px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/6wbkp8i0_Social_Insta.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.facebook.com/calm" alt="Facebook" icon-size="53px" icon-height="49px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iludi483_Social_Facebook.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.tiktok.com/@calm" alt="Tik Tok" icon-size="53px" icon-height="49px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/0e49084i_Social_Tik-Tok.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.linkedin.com/company/calm" alt="Linkedin" icon-size="53px" icon-height="49px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/wkm81n4v_Social_Linked.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.threads.net/@calm" alt="Threads" icon-size="53px" icon-height="49px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/mdib1yst_Social_Threads.png"></mj-social-element></mj-social></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-left="20px" background-color="#FFFFFF"><mj-group><mj-column padding-right="8px" padding-left="8px" width="50%"><mj-image align="right" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/wb3sgsus_App-Store.png" alt="Download on the App Store" width="127px" href="https://apps.apple.com/app/calm"></mj-image></mj-column><mj-column padding-right="8px" padding-left="8px" width="50%"><mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/d3qtmya0_Google-Play.png" alt="Get it on Google Play" width="127px" href="https://play.google.com/store/apps/details?id=com.calm.android"></mj-image></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="30px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-text align="center" color="#6D7278" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="15px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px" font-weight="400">Have a question? Visit our&nbsp;<span><a href="https://help.calm.com">Help Center</a></span></mj-text><mj-text align="center" color="#6D7278" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px" font-weight="400">This email was sent to hello@SmilesDavis.yeah as a registered user of Calm.com, Inc. 555 Bryant Street, Suite 262, Palo Alto, CA 94301</mj-text><mj-text align="center" color="#389FE6" font-family="Figtree, 'Google Sans', Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="600"><span><a href="{{unsubscribeUrl}}">Unsubscribe from email offers</a></span> |&nbsp;<span><a href="#">View email in browser</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template38",
    title: "Template 38",
    thumbnail: thumb38,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#E8EEFC" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px" background-color="#66ABEE"><mj-column>

        <mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="20px" padding-bottom="0px" padding-left="20px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5tcczr6n_1773339200767_EM1_B2C_Mar17_Desktop_600px_2x_01KKHM1JVZC0F814KKDJY4C8VB.png" alt="Gamma Imagine. Create any graphic." width="600px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL2NyZWF0ZS9nZW5lcmF0ZSIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6MTk2OX0/de376224f74e9c091ffb988b913ea3df162e8147183cc24f29cfa5e1b1862569"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#66ABEE"><mj-column background-color="#FEFEFE" border-radius="18px">

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="40px" padding-right="40px" padding-bottom="0px" padding-left="40px">Smiles, we're launching three major updates that work together to keep your best work in one place:</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="44px" line-height="1.1" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="0px" padding-left="40px" font-weight="700">Gamma Imagine</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="20px" padding-left="40px">Describe an idea — however vague — and&nbsp;<strong>Gamma Imagine</strong> explores different creative angles for you. Pick the direction that feels right, and Imagine produces polished, on-brand options in seconds. Logos, infographics, diagrams, social visuals, and more.</mj-text>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="40px" padding-bottom="0px" padding-left="40px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/6o5qy46b_1773426330103_Feature_GammaImagine_480px_2x_01KKM74J6EHD7DM6SHVJM9KJG3.png" alt="Pick a starting concept" width="480px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL2NyZWF0ZS9nZW5lcmF0ZSIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6MTk2OX0/de376224f74e9c091ffb988b913ea3df162e8147183cc24f29cfa5e1b1862569"></mj-image>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="0px" padding-left="40px">For the next 30 days,&nbsp;<strong>Gamma Imagine</strong> is available across all plans with expanded usage.&nbsp;<a href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL2NyZWF0ZS9nZW5lcmF0ZSIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6MTk2OX0/de376224f74e9c091ffb988b913ea3df162e8147183cc24f29cfa5e1b1862569" style="color: #1862D4; text-decoration: underline;"><strong>Try it now</strong></a> and see what you come up with.</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="44px" line-height="1.1" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="0px" padding-left="40px" font-weight="700">Connectors</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="20px" padding-left="40px">Gamma is everywhere you work. With a new suite of connectors, Gamma is now inside the tools you use every day: Claude, ChatGPT, and dozens more.</mj-text>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="40px" padding-bottom="0px" padding-left="40px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/uzzj9f6p_1773426331510_Feature_Integrations_480px_2x_01KKM74KHMX7SMYH9JF0V2H86X.png" alt="Gamma Connectors" width="480px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL2ludGVncmF0aW9ucyIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6MTk2OH0/19e3bc327c4c18195c3564e19fca760bb392d6c71e72284be5360baba72ee8fd"></mj-image>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="0px" padding-left="40px">Turn a conversation with Claude into a presentation. Turn an email into a deck for a prospect. The context is already there. Gamma turns it into something you can present, without switching tabs.</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="44px" line-height="1.1" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="20px" padding-left="40px" font-weight="700">AI-native Templates</mj-text>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="40px" padding-bottom="0px" padding-left="40px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/0wcdtgj0_1773426333201_Feature_Templates_Blue_480px_2x_01KKM74N6HT7TKA9G14SPFFBM2.png" alt="Generate from template" width="480px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL3RlbXBsYXRlcyIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6ODR9/0c7c128f2aa0e8c3db5b97c6f9af1f3117d2159208bdfe78e8b4c1aac58da968"></mj-image>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="0px" padding-left="40px">We've completely rebuilt the template experience. Pick any template, tell Gamma what you need, and get a complete, polished deck in seconds. Change the content, the topic, the look. Gamma rebuilds the rest, with your brand intact every time.</mj-text>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="20px" padding-left="40px"><a href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwL3RlbXBsYXRlcyIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6ODR9/0c7c128f2aa0e8c3db5b97c6f9af1f3117d2159208bdfe78e8b4c1aac58da968" style="color: #1862D4; text-decoration: underline;"><strong>Get started with 100+ new</strong></a>, professionally designed templates.</mj-text>

        <mj-button background-color="#1862D4" border-radius="50px" color="#FEFEFE" font-family="Helvetica, sans-serif" font-size="18px" font-weight="400" line-height="1.5" inner-padding="12px 30px 12px 30px" padding="10px 25px" padding-top="0px" padding-right="40px" padding-bottom="0px" padding-left="40px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vZ2FtbWEuYXBwLyIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6NX0/b2affcfd3d0caa17592b9e49d58ac5725631270efa59f0cb3b66fe7a00040d08">Create Something Today&nbsp;<img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/lq02cyd5_1765815612476_icon_stars_26px_1x_01KCHCZXCEWKFY8GNJ4GJ0YWKF.png" alt="star icon" height="20" style="display:inline-block; vertical-align:middle;" /></mj-button>

        <mj-text color="#000E21" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="40px" padding-bottom="40px" padding-left="40px">Best,<br />Grant<br />Co-founder & CEO, Gamma</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#343680"><mj-column>

        <mj-spacer padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/tis3q6uq_1766434735049_em1_footer_600px_2x_en_01KD3VE1JNHKZ0EGNVP0QTKH2C.png" alt="Gamma Footer" width="600px"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="40px" padding-bottom="0px" background-color="#FEFEFE"><mj-column>

        <mj-text align="center" color="#1862D4" font-family="Helvetica, sans-serif" font-size="24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">See You Soon!</mj-text>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="20px" padding-left="0px" font-weight="500">Team Gamma</mj-text>

        <mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="32px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8veC5jb20vZ2FtbWFhcHAiLCJpbnRlcm5hbCI6IjhlOGYwN2YxMGRkMGU3MDE4MWNjYjcxOSIsImxpbmtfaWQiOjEwNzl9/7b852f3884fec89bb016ac7d1873840ae9cae497891d4fad55818cdb72c78e2d" alt="X" icon-size="32px" icon-height="32px" background-color="#FEFEFE" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/p4pibm5c_1765570932691_social_x_32px_1x_01KCA3MVAZ7NSPB2WNBT28FFV5.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vd3d3Lmluc3RhZ3JhbS5jb20vbWVldGdhbW1hIiwiaW50ZXJuYWwiOiI4ZThmMDdmMTBkZDBlNzAxODFjY2I3MTkiLCJsaW5rX2lkIjoyNDd9/78d9796d45b1231748a1b85ec9a0a22a85d14084786f3b19cb37c700ccc918c6" alt="Instagram" icon-size="32px" icon-height="32px" background-color="#FEFEFE" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9gl86wy6_1765570932167_social_ig_32px_1x_01KCA3MTTKA6KXPKV7F7ZDACRG.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vd3d3LmxpbmtlZGluLmNvbS9jb21wYW55L2dhbW1hLWFwcC8iLCJpbnRlcm5hbCI6IjhlOGYwN2YxMGRkMGU3MDE4MWNjYjcxOSIsImxpbmtfaWQiOjkzfQ/f14df2deeb37ecc79397b3e4f6b4d552a43e34a9ebdd278002833c8fab532158" alt="LinkedIn" icon-size="32px" icon-height="32px" background-color="#FEFEFE" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9l0g7596_1765570932427_social_li_32px_1x_01KCA3MV2Q559JS0AQFS81F52H.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vd3d3LnlvdXR1YmUuY29tL0BtZWV0Z2FtbWEiLCJpbnRlcm5hbCI6IjhlOGYwN2YxMGRkMGU3MDE4MWNjYjcxOSIsImxpbmtfaWQiOjQ1OH0/4521a9cb57a5a6672e78528a7553c11cab43cea221463daa0212a90a65e810ed" alt="YouTube" icon-size="32px" icon-height="32px" background-color="#FEFEFE" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/m7t13d0m_1765570932949_social_yt_32px_1x_01KCA3MVK07BEQ6KSRVDWA89NB.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vd3d3LnRpa3Rvay5jb20vQGdhbW1hLmFwcCIsImludGVybmFsIjoiOGU4ZjA3ZjEwZGQwZTcwMTgxY2NiNzE5IiwibGlua19pZCI6MjQ4fQ/4f8998191168db426e8346bfa4ebed659f0590fb8254b28e9b1b61d2b7c40238" alt="TikTok" icon-size="32px" icon-height="32px" background-color="#FEFEFE" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/dxasr9ch_1765815149180_social_tt_32px_1x_01KCHCHRZ4WG6Z515XSN3PRDBM.png"></mj-social-element></mj-social>

        <mj-text color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="48px" padding-bottom="20px" padding-left="48px" font-weight="500">Need help? Have a question? Check out our&nbsp;<a href="https://email.gamma.app/e/c/eyJlbWFpbF9pZCI6ImRnU09qd2NEQUlITXR4bUF6TGNaQVowQ25rUlk0QmhybEFZcVgwWlB3UT09IiwiaHJlZiI6Imh0dHBzOi8vd3d3LnlvdXR1YmUuY29tL0BtZWV0Z2FtbWEvdmlkZW9zIiwiaW50ZXJuYWwiOiI4ZThmMDdmMTBkZDBlNzAxODFjY2I3MTkiLCJsaW5rX2lkIjoxMzA5fQ/f154cbca2bf5a7054b5f19fd042279f61280adaeea236ecbefa87677e12c73ba" style="color: #1862D4; text-decoration: underline;"><strong>YouTube</strong></a> and&nbsp;<a href="#" style="color: #1862D4; text-decoration: underline;"><strong>Help Center</strong></a> or contact our Support Team.</mj-text>

        <mj-divider border-width="1px" border-color="#CDDAFA" padding="10px 25px" padding-right="48px" padding-left="48px"></mj-divider>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"><span><a href="#">View online</a></span>    <span><a href="{{unsubscribeUrl}}">Unsubscribe</a></span></mj-text>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">2261 Market Street #4544</mj-text>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">San Francisco, CA 94114</mj-text>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">https://gamma.app/</a></span></mj-text>

        <mj-text align="center" color="#1D1D1D" font-family="Helvetica, sans-serif" font-size="16px" line-height="1.5" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="40px" padding-left="0px" font-weight="500">© 2026 Gamma Tech, Inc., All rights reserved.</mj-text>

      </mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template39",
    title: "Template 39",
    thumbnail: thumb39,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#EEEEEE" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="30px" padding-bottom="10px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/xcsaks0v_2009918b-f59e-4fc4-82ba-d100d3df7466.gif" alt="PRESS Healthfoods" width="140px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3eLemZPboGnkWI6kw-2BVdrS2Eca8ZofYewA5PEbBua3Y3tt-2BCkYT8oVaad95uWO7tG9a1Q1cGy2AKtvnXONgxLMu"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="9px" padding-right="18px" padding-bottom="9px" padding-left="18px" background-color="#FFFFFF"><mj-column>

        <mj-text align="center" color="#242424" font-family="'haboro-soft-condensed', 'Lucida Sans', Geneva, Verdana, sans-serif" letter-spacing="1px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700"><span><a href="#">SHOP</a></span>     <span>CLEANSES</span>     <span>MEAL PLANS</span></mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bxyg3rcy_bc70f065-286f-48d9-9aaf-a31f97679d2b.gif" alt="Use the code PW46RU2Y2 at checkout to redeem your 10% OFF." width="600px"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/73a6cebt_press-hero.jpg" alt="Natural plant-based nutrition Transform Your World" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3fyAIgNcJInumHCQ4TFRrKrkoytwcIcsad9IIVy6si7Wk"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hjzrf0ao_6ad440b6-1e98-4540-9320-506a4efcf71c.png" alt="We understand the challenges of maintaining a healthy lifestyle amidst a busy schedule." width="600px"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/h9tynr4q_91923b8c-a804-4fc7-98e1-52230dcca8fe.png" alt="PRESS Healthfoods Products" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3frRWD6mx06l3s9qn3d08uKgUIAMOdQzOdZZ-2F7XmWwvrA"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9istl89i_e165b813-2ac8-4f1c-a9ba-b6b8c1f93eaa.png" alt="Our range of products is designed to ensure you can nourish your body even when you're pressed for time" width="600px"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/biatvkpg_41ba5053-7e4b-4e42-9032-01223b2fee91.png" alt="Meal Plans: Streamline your healthy eating habits" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3cGumQbiK4CWyV-2B3hWPkzJmHGMs3kPQTxxO7fuFtLrX1WMslmVvZ0lA564r5Whou8w"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/lv4xms8a_edd89760-5255-4142-b12b-3c7afa20182d.png" alt="Beginner Cleanse Juices: Kickstart your journey to wellness" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3eHkxdy7AMk6cKr7P39s8pVflIKUBlGXyvZKZChcXn-2Bzs"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/tl91i3iv_7cf315bb-806c-4590-9109-8ca80dd20b08.png" alt="Combine our Meal Plans and Beginner Cleanse Juices. CODE: PW46RU2Y2" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3eLemZPboGnkWI6kw-2BVdrS2Eca8ZofYewA5PEbBua3Y3t"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/w29sq1nh_490104ae-8050-45e1-ac13-02b0f03a331c.gif" alt="What people say" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPW6yUbWwfdlvd1RdUDB77PKx3yGHPEo2kPfl69kOHzXDy"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1o58f7w2_e563725d-88c2-4244-b18e-4c321c7b9018.jpeg" alt="Explore our Signature Cleanses" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3ffARS9qwUeb9plIQkHel1QVGm3ogr-2BglZ-2FzfhUtBW2qhR"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/o2825ecv_f3e1c916-4330-435a-b496-3b0dd759cbaf.jpeg" alt="Dive into our Squeeze Magazine for wellness insights" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3feAvwSc4RsBiS8TwgZg47dEdvlTwdNbFgTzwwDK5seoP"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/xicza6nx_7d15f34f-f909-4788-a87b-be38ed30557b.jpeg" alt="Follow @press_healthfoods" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPaZ8-2BydFQ6nx6MsBg1IrdrhPqPF5Sfb271oJmFtBMs94d5TczowVXsHl0Vxljl7FGLl"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/ntictras_c167f9da-6d60-4dd2-a6a4-e46afb243d59.jpeg" alt="VOGUE | FORBES | WOMENSHEALTH | THE GUARDIAN | HELLO!" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3fyAIgNcJInumHCQ4TFRrKrkoytwcIcsad9IIVy6si7Wk"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/sccu8rs0_72a758e1-9673-438d-99d3-a843fe3fbd89.jpeg" alt="100% plant-based, Natural pharmacy, It has to taste great, Plastic neutral" width="600px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3fyAIgNcJInumHCQ4TFRrKrkoytwcIcsad9IIVy6si7Wk"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px" background-color="#FFFFFF"><mj-column>

        <mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="32px" mode="horizontal" padding="10px 25px" padding-top="9px" padding-right="9px" padding-bottom="9px" padding-left="9px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPQjgLPq0iagLnjPKvn3ZIb-2BalDoGXk8OKTA8lFQe9eKi9" alt="FB" icon-size="32px" icon-height="32px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/51dhiufo_67cde7e3-1381-402f-8fd8-7608f6f38e4d.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPaZ8-2BydFQ6nx6MsBg1IrdrhPqPF5Sfb271oJmFtBMs94d5TczowVXsHl0Vxljl7FGLl" alt="IG" icon-size="32px" icon-height="32px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/t1apq22z_c784ee10-3d52-4d99-903f-cdd81fff6b42.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPbdypPpmA8TMqWqknsWzk4PY7eahd37COP6QHZg-2BDRJw-2FpL3g9MADl3WVbA-2FhdYN08g" alt="LD" icon-size="32px" icon-height="32px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/itg8xj6o_dfebcd81-9c75-48b2-afc6-e811fcb10e94.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://trk.klclick1.com/ls/click?upn=u001.-2F767h7s0agg-2BCNAGtNdRPUH3mYY29WZUX8cV8xvsb3fyAIgNcJInumHCQ4TFRrKrkoytwcIcsad9IIVy6si7Wk" alt="WEB" icon-size="32px" icon-height="32px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/k6kma8o2_701e05a6-6451-401f-a71c-2dd041c18d16.png"></mj-social-element></mj-social>

        <mj-text align="center" font-family="Arial, Helvetica, sans-serif" font-size="11px" line-height="1.5" padding="10px 25px" padding-top="9px" padding-right="18px" padding-bottom="19px" padding-left="18px">No longer want to receive our emails?&nbsp;<span><a href="{{unsubscribeUrl}}">Unsubscribe</a></span>.<br /><span><a href="#">Manage Preferences</a></span><br />PRESS, 28 Poland St, London, W1F 8QW</mj-text>

      </mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template40",
    title: "Template 40",
    thumbnail: thumb40,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#F5F4F4" css-class="mjbody">
    <mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1nuiklsp_4dc09e0c-6d5f-461e-b71e-777d778b545c.jpeg" alt="Final call: Order by 2/5 at 11:59 PM PT for Valentine's delivery." width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_0"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/qi5nnokl_aa18aac7-cf0c-4120-9619-26908cf30de7.jpeg" alt="Stanley 1913" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_1"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iv39w4pn_6814b20a-85cb-47f1-b7c4-36b1724c3c31.gif" alt="There is still time for Valentine's gifts" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_2"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/02m8yz03_171ade55-583f-4ca1-92f3-ddf02fe738fb.jpeg" alt="Good news, procrastinators. Order Valentine's gifts by 2/5. Shop Now." width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_3"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/0tyxvnuf_43fa1154-3e47-4854-a4e1-18a98ad2e08f.jpeg" alt="Shop gifts" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_4"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/4q9y4ix0_33224dd9-9a60-4fb1-b56b-f942af6d6161.jpeg" alt="Quencher H2.0 Flowstate Tumbler 30 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_5"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/b3qzwcwq_3760fdb3-eae5-4a49-9095-87b59a8b9fe1.jpeg" alt="Valentine's Day Textured Reserve Wine Tumbler 11 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_6"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/31siln41_111eb76b-10b3-4ff0-a06d-3d003a9f2b53.jpeg" alt="Quencher H2.O FlowState Tumbler 20 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_7"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/owtzl3mw_26ff80f8-a7d8-46bf-ba57-1552cc39fe7e.jpeg" alt="All Day Julienne Mini Cooler 10 Can" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_8"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/p7q7u07k_8d4bf707-d21c-464f-a023-59aaa4ed5bd6.jpeg" alt="Quencher ProTour Flip Straw Tumbler 40 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_9"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/nvor6wz8_dc563bbe-ca64-4f61-a94b-8f29105fece9.jpeg" alt="Quencher ProTour Flip Straw Tumbler 30 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_10"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/27ys0h06_6f761164-e492-4123-86a5-d2957159df7e.jpeg" alt="Shop All" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_11"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/y2253y3l_08a9f4a2-c03b-43d2-9707-7fb076c1c52a.jpeg" alt="Shop Collection" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_12"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/euw9q96p_dfb43cd6-f511-4cf5-b041-c33320170857.jpeg" alt="More to love" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_13"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/x7bh9l14_0767b8ee-1136-41d1-bed2-ec024e42a3af.jpeg" alt="Stanley 1913 x Anto" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_14"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1k19vvsj_5b3f9354-4baf-41eb-ab0f-d89486cd1c97.jpeg" alt="New Arrivals" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_15"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iuvd21qz_d47f3ecd-642b-4ac7-931a-9442852e29c7.jpeg" alt="Stanley 1913" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_16"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/k9bgf8gh_d6a459b8-4e25-444d-a1ee-a04cc0bf0832.jpeg" alt="Stanley" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_21"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9m2e5g4n_sms-updates.jpeg" alt="Sign Up For SMS Updates" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_22"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/uzaumb3p_be82703d-00b8-4604-bbf8-b2736c6a56f3.jpeg" alt="Buy with Prime" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_23"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gpal4r8q_e04151a8-0afc-40ee-a874-e0bfb988272a.jpeg" alt="Stanley" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_24"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#000000" padding="20px 0" padding-right="18px" padding-left="18px"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px">*To receive your gifts in time for Valentine's Day, place your order by 2/5 at 11:59PM PT. Excludes Stanley Create customization orders.</mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-left="0px">STANLEY ® ©PMI WW Brands, LLC<br />2401 Elliott Avenue, Seattle, WA 98121</mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-left="0px"><span><a href="#">Manage Your Preferences</a></span> |&nbsp;<span><a href="{{unsubscribeUrl}}">Unsubscribe</a></span></mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="#">Contact Us</a></span> |&nbsp;<span><a href="#">Privacy Policy</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template41",
    title: "Template 41",
    thumbnail: thumb41,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#F5F4F4" css-class="mjbody">
    <mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1nuiklsp_4dc09e0c-6d5f-461e-b71e-777d778b545c.jpeg" alt="Final call: Order by 2/5 at 11:59 PM PT for Valentine's delivery." width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_0"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/qi5nnokl_aa18aac7-cf0c-4120-9619-26908cf30de7.jpeg" alt="Stanley 1913" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_1"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iv39w4pn_6814b20a-85cb-47f1-b7c4-36b1724c3c31.gif" alt="There is still time for Valentine's gifts" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_2"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/02m8yz03_171ade55-583f-4ca1-92f3-ddf02fe738fb.jpeg" alt="Good news, procrastinators. Order Valentine's gifts by 2/5. Shop Now." width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_3"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/0tyxvnuf_43fa1154-3e47-4854-a4e1-18a98ad2e08f.jpeg" alt="Shop gifts" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_4"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/4q9y4ix0_33224dd9-9a60-4fb1-b56b-f942af6d6161.jpeg" alt="Quencher H2.0 Flowstate Tumbler 30 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_5"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/b3qzwcwq_3760fdb3-eae5-4a49-9095-87b59a8b9fe1.jpeg" alt="Valentine's Day Textured Reserve Wine Tumbler 11 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_6"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/31siln41_111eb76b-10b3-4ff0-a06d-3d003a9f2b53.jpeg" alt="Quencher H2.O FlowState Tumbler 20 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_7"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/owtzl3mw_26ff80f8-a7d8-46bf-ba57-1552cc39fe7e.jpeg" alt="All Day Julienne Mini Cooler 10 Can" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_8"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/p7q7u07k_8d4bf707-d21c-464f-a023-59aaa4ed5bd6.jpeg" alt="Quencher ProTour Flip Straw Tumbler 40 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_9"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/nvor6wz8_dc563bbe-ca64-4f61-a94b-8f29105fece9.jpeg" alt="Quencher ProTour Flip Straw Tumbler 30 OZ" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_10"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/27ys0h06_6f761164-e492-4123-86a5-d2957159df7e.jpeg" alt="Shop All" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_11"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/y2253y3l_08a9f4a2-c03b-43d2-9707-7fb076c1c52a.jpeg" alt="Shop Collection" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_12"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/euw9q96p_dfb43cd6-f511-4cf5-b041-c33320170857.jpeg" alt="More to love" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_13"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#a75190" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/x7bh9l14_0767b8ee-1136-41d1-bed2-ec024e42a3af.jpeg" alt="Stanley 1913 x Anto" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_14"></mj-image></mj-column><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/1k19vvsj_5b3f9354-4baf-41eb-ab0f-d89486cd1c97.jpeg" alt="New Arrivals" width="300px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_15"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iuvd21qz_d47f3ecd-642b-4ac7-931a-9442852e29c7.jpeg" alt="Stanley 1913" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_16"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/k9bgf8gh_d6a459b8-4e25-444d-a1ee-a04cc0bf0832.jpeg" alt="Stanley" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_21"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9m2e5g4n_sms-updates.jpeg" alt="Sign Up For SMS Updates" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_22"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/uzaumb3p_be82703d-00b8-4604-bbf8-b2736c6a56f3.jpeg" alt="Buy with Prime" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_23"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#FFFFFF" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gpal4r8q_e04151a8-0afc-40ee-a874-e0bfb988272a.jpeg" alt="Stanley" width="600px" href="https://ctrk.klclick.com/l/01KGQ4YF2D2RP2A9K3NDFXZ1GW_24"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" background-color="#000000" padding="20px 0" padding-right="18px" padding-left="18px"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px">*To receive your gifts in time for Valentine's Day, place your order by 2/5 at 11:59PM PT. Excludes Stanley Create customization orders.</mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-left="0px">STANLEY ® ©PMI WW Brands, LLC<br />2401 Elliott Avenue, Seattle, WA 98121</mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-left="0px"><span><a href="#">Manage Your Preferences</a></span> |&nbsp;<span><a href="{{unsubscribeUrl}}">Unsubscribe</a></span></mj-text><mj-text align="center" color="#FFFFFF" font-family="'Stanley Favorit', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="#">Contact Us</a></span> |&nbsp;<span><a href="#">Privacy Policy</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template42",
    title: "Template 42",
    thumbnail: thumb42,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="700px" background-color="#d6d6d5" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding-top="32px" padding-bottom="0px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#e8e8e8"><mj-group><mj-column width="70%">

          <mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/swe0g4n4_t11gdmxv_7id5k66p_uber-logo.png" alt="Uber" width="94px"></mj-image>

        </mj-column><mj-column width="30%">

          <mj-text align="right" color="#4b4b4b" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="12px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Nov 28, 2025</mj-text>

          <mj-text align="right" color="#4b4b4b" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="12px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">8:32 AM</mj-text>

        </mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding-top="24px" padding-bottom="32px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#e8e8e8"><mj-column padding-right="16px" padding-left="15px" width="70%">

        <mj-text color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="44px" line-height="52px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="700">Thanks for purchasing an Uber Gift, Smiles Davis</mj-text>

        <mj-text color="#000" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="400">They're going to love it. Check your order details below.</mj-text>

      </mj-column><mj-column vertical-align="bottom" width="30%">

        <mj-image align="right" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/kbvxvq4m_7z7935zt_lp1753c2_uber-gift.png" alt="Uber Gift" width="160px"></mj-image>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="32px" padding-bottom="0px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column width="50%">

        <mj-text color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="32px" line-height="40px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">Total</mj-text>

      </mj-column><mj-column width="50%">

        <mj-text align="right" color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="32px" line-height="40px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">$425.00</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="24px" padding-bottom="0px" padding-left="64px" padding-right="64px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-divider border-width="1px" border-color="#f3f3f3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="15px" padding-bottom="15px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column width="50%">

        <mj-text color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Gift Card Amount</mj-text>

      </mj-column><mj-column width="50%">

        <mj-text align="right" color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$500.00</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="0px" padding-bottom="15px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column width="50%">

        <mj-text color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Gift card purchase discount</mj-text>

      </mj-column><mj-column width="50%">

        <mj-text align="right" color="#080" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500" css-class="fare-green">-$75.00</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="0px" padding-bottom="16px" padding-left="64px" padding-right="64px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-divider border-width="1px" border-color="#f3f3f3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="16px" padding-bottom="8px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-text color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="24px" line-height="32px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">Payments</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="12px" padding-bottom="12px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-group><mj-column width="20%">

          <mj-image height="32px" padding="10px 25px" padding-top="0px" padding-right="18px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/phj3o93z_jhgxl95k_8k5851nl_mastercard_3x.png" alt="Mastercard" width="35px"></mj-image>

        </mj-column><mj-column width="45%">

          <mj-text color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Capital One ••••6500</mj-text>

          <mj-text color="#4b4b4b" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="400">Nov 28, 2025 8:32 AM</mj-text>

        </mj-column><mj-column width="33.333333333333336%">

          <mj-text align="right" color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$425.00</mj-text>

        </mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding-top="0px" padding-bottom="8px" padding-left="64px" padding-right="64px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-divider border-width="1px" border-color="#f3f3f3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="16px" padding-bottom="16px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-text color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="24px" line-height="32px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">Additional information</mj-text>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="10px" padding-bottom="10px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-group><mj-column width="40%">

          <mj-text color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Gift from</mj-text>

        </mj-column><mj-column width="60%">

          <mj-text align="right" color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Smiles Davis</mj-text>

        </mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding-top="0px" padding-bottom="0px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-group><mj-column width="40%">

          <mj-text color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Gift to</mj-text>

        </mj-column><mj-column width="60%">

          <mj-text align="right" color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Really Good Emails</mj-text>

        </mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding-top="16px" padding-bottom="16px" padding-left="64px" padding-right="64px" padding="20px 0" background-color="#ffffff"><mj-column>

        <mj-divider border-width="1px" border-color="#f3f3f3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"></mj-divider>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="16px" padding-bottom="32px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#ffffff"><mj-column padding-top="16px" padding-right="16px" padding-bottom="16px" padding-left="16px" border-radius="16px">

        <mj-text color="#000" font-family="UberMoveBold, Arial, sans-serif" font-size="20px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="700">Need help?</mj-text>

        <mj-text color="#000" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px" font-weight="400">Our support team is happy to help with any concern you might have.</mj-text>

        <mj-button background-color="#f3f3f3" border-radius="8px" color="#000" font-family="UberMoveTextMedium, Arial, sans-serif" font-size="14px" font-weight="500" line-height="16px" inner-padding="10px 16px 10px 16px" padding="10px 25px" padding-right="0px" padding-left="0px" href="https://help.uber.com" width="100%"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/rrb7gbtx_l2bz9vs3_wv4rohin_icon_support_email.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Contact support</mj-button>

      </mj-column></mj-section><mj-section background-repeat="no-repeat" padding-top="32px" padding-bottom="32px" padding-left="32px" padding-right="32px" padding="20px 0" background-color="#000000"><mj-column width="50%">

        <mj-text color="#a6a6a6" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" css-class="entity-info">Uber B.V.<br />Burgerweeshuispad 301<br />1076 HR Amsterdam</mj-text>

        <mj-image align="left" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/2dfzkkuv_u3tjup5z_3a6pixnk_uber_footer_icon.png" alt="Uber" width="74px"></mj-image>

      </mj-column><mj-column width="50%">

        <mj-text align="right" color="#000" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="https://auth.uber.com/login">My Account</a></span></mj-text>

        <mj-text align="right" color="#000" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="https://www.uber.com/privacy">Privacy policy</a></span></mj-text>

        <mj-text align="right" color="#000" font-family="UberMoveTextRegular, Arial, sans-serif" font-size="16px" line-height="20px" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="https://www.uber.com/legal">Terms and Conditions</a></span></mj-text>

        <mj-social align="right" font-family="UberMoveTextRegular, Arial, sans-serif" icon-size="30px" mode="horizontal" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="0px" padding-left="0px"><mj-social-element font-family="UberMoveTextRegular, Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.facebook.com/uber" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/cxhzkclel5ojn_dzo1o7v_facebook.png"></mj-social-element><mj-social-element font-family="UberMoveTextRegular, Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.instagram.com/uber" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/yyeuinjdwnclhwonzm04p_instagram.png"></mj-social-element><mj-social-element font-family="UberMoveTextRegular, Arial, sans-serif" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.youtube.com/uber" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/j5wv-vgx4tse62wzjde4q_youtube.png"></mj-social-element></mj-social>

      </mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template43",
    title: "IMBŌDHI - Order Confirmed",
    thumbnail: thumb43,
    mjml: `<mjml>
  <mj-head>
    <mj-title>IMBŌDHI - Order Confirmed</mj-title>
  </mj-head>
  <mj-body background-color="#E6E4E4" width="600px">
    <mj-section background-color="#FFFFFF" padding="20px 0">
      <mj-column padding="0">
        <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bilbzex8_v0u7c5or_c0b93450-6bd5-4948-a7eb-d5583cb72e85.png" alt="IMBŌDHI" width="130px" padding="0" align="center" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_0" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#FFFFFF" padding="0">
      <mj-column padding="0">
        <mj-text font-family="Georgia, Times, serif" font-size="35px" line-height="1.1" color="#5B4040" padding="15px 18px 9px 18px" align="center" font-weight="700">Your Order Has Been Placed</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="26px" line-height="1.1" color="#3B3939" padding="0 18px 9px 18px" align="center" font-weight="700">Comfort Is On The Horizon</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="9px 18px" align="center">Olive, your order #650050 has been confirmed!</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="9px 18px" align="center">Soon your new IMBŌDHI will make you feel held in all the right places and free in all the right ways.</mj-text>
        <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/pz6gynmb_7pdrufjq_71fabd92-082d-4e1d-b02f-e55a86809705.png" alt="Track Your Order" width="245px" padding="15px 0 40px 0" align="center" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_2" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#FFFFFF" padding="0 18px">
      <mj-column padding="0" width="50%">
        <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jhyh6ygo_ujdbtjwk_sbj-mobile.jpg" alt="Sample Sale Jumpsuit" width="300px" padding="0" />
      </mj-column>
      <mj-column padding="0" width="50%" vertical-align="middle">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="0 9px" font-weight="bold">Sample Sale Jumpsuit</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="15px" line-height="1.5" color="#3B3939" padding="0 9px">Quantity: 2</mj-text>
      </mj-column>
    </mj-section>

    <mj-section background-color="#F6F2EF" padding="15px 18px">
      <mj-column padding="0" width="50%">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" font-weight="bold" align="left">Subtotal:</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" font-weight="bold" align="left">Tax:</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" font-weight="bold" align="left">Shipping:</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" font-weight="bold" align="left">Total:</mj-text>
      </mj-column>
      <mj-column padding="0" width="50%">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" align="right">$80.00</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" align="right">$6.20</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" align="right">$</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#3B3939" padding="4px 9px" align="right">$86.20</mj-text>
      </mj-column>
    </mj-section>

    <mj-section background-color="#FFFFFF" padding="40px 0 0 0">
      <mj-column padding="0">
        <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/nvhlsfu5_sfuwd4wt_f4fac3e1-9da4-41b2-bcd1-316e74af6fe1.jpeg" alt="What Guides Our Sustainability Ethos" width="600px" padding="0" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_3" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="30px 18px 9px 18px">
      <mj-column padding="0">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" color="#FFFFFF" padding="0 0 9px 0" align="center">Questions about your order? Reach us <a href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_5" style="color: #D99D71; text-decoration: none; font-weight: lighter;">here</a> or venture over to our <a href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_6" style="color: #D99D71; text-decoration: none; font-weight: lighter;">FAQ page</a>.</mj-text>
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="0 200px">
      <mj-column padding="0">
        <mj-divider border-color="#FFFFFF" border-width="2px" padding="0" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="20px 0">
      <mj-column padding="0">
        <mj-image src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/84wq3w28_essu35wn_cbfd04f7-0acd-43b0-9892-44ede20e8071.png" alt="Clean Fabrics + CA Made / Buy now, pay later with Shop Pay / Free Shipping" width="490px" padding="0" align="center" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="0 200px">
      <mj-column padding="0">
        <mj-divider border-color="#FFFFFF" border-width="2px" padding="0" />
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="20px 0">
      <mj-column padding="0">
        <mj-social font-size="0px" icon-size="32px" mode="horizontal" padding="0" align="center" border-radius="0px">
          <mj-social-element name="instagram" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_7" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bmv4bbfr_8k8xiwnb_instagram_96.png" alt="Instagram" icon-size="32px" icon-height="32px" padding="0 5px" background-color="#5B4040" />
          <mj-social-element name="pinterest" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_8" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/c70wiox0_7oi8en3b_pinterest_96.png" alt="Pinterest" icon-size="32px" icon-height="32px" padding="0 5px" background-color="#5B4040" />
          <mj-social-element name="facebook-noshare" href="https://trk.send.imbodhi.co/l/01K7Z8W9QD4SZM726AQDM17PBF_9" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/im3al1f3_djbjvv05_facebook_96.png" alt="Facebook" icon-size="32px" icon-height="32px" padding="0 5px" background-color="#5B4040" />
        </mj-social>
      </mj-column>
    </mj-section>

    <mj-section background-color="#5B4040" padding="9px 18px 20px 18px">
      <mj-column padding="0">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.5" color="#FFFFFF" padding="0" align="center">IMBŌDHI</mj-text>
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.5" color="#FFFFFF" padding="0" align="center">2443 Fillmore St #380 - 8481 San Francisco, California 94115</mj-text>
      </mj-column>
    </mj-section>

    <mj-section background-color="#FAFAFA" padding="10px 18px">
      <mj-column padding="0">
        <mj-text font-family="Helvetica, Arial, sans-serif" font-size="12px" line-height="1.5" color="#444444" padding="0" align="center">You received this email from IMBŌDHI. If you would like to unsubscribe, <a href="#" style="color: #D99D71; text-decoration: none;">click here</a>.</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>
`,
  },
  {
    id: "template44",
    title: "Template 44",
    thumbnail: thumb44,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
    <mj-font name="SofiaPro" href="https://fonts.googleapis.com/css2?family=Sofia+Sans:wght@400;500;600;700&display=swap" />
  </mj-head>
  <mj-body width="680px" background-color="#F5F5F5" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="15px" background-color="#F5F5F5"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/r2st533u_original.png" alt="hers" width="80px" href="https://www.forhers.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="40px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF" border-radius="20px"><mj-column><mj-text align="center" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="115px" letter-spacing="-1px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" font-weight="500"><span style="color:#91DFC4;">I</span><span style="color:#8ADDC6;">t</span><span style="color:#8ADDC6;">'</span><span style="color:#7ED8C9;">s</span>&nbsp;<span style="color:#71D2CE;">s</span><span style="color:#6DCAD2;">o</span><span style="color:#6BC4D5;">o</span><span style="color:#69BED9;">n</span></mj-text><mj-text align="center" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="24px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="20px" padding-bottom="30px" padding-left="20px">Way to start a healthy habit. Your order's in the works, but there's more to explore in the meantime.</mj-text><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/hat272f8_hers-hero.jpg" alt="hers products" width="612px" href="#"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px"><mj-column><mj-spacer height="0px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section padding="20px 0" padding-right="30px" padding-left="30px"><mj-group vertical-align="middle"><mj-column vertical-align="middle" width="50%"><mj-text font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="26px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" font-weight="400">Order details</mj-text></mj-column><mj-column vertical-align="middle" width="50%"><mj-text align="right" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px"><span><a href="#">ORDER_ID</a></span></mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="0px" padding-left="30px" background-color="#FFFFFF"><mj-column><mj-text color="#757575" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px">Items ordered:</mj-text><mj-text font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="30px" padding-left="0px">Detox Scalp Scrub</mj-text><mj-divider border-width="1px" border-color="#D2D3D2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="30px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="30px" padding-bottom="40px" padding-left="30px" background-color="#FFFFFF" border-radius="0 0 20px 20px"><mj-group><mj-column width="50%"><mj-text color="#757575" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Total charge:</mj-text><mj-text color="#757575" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px">Payment method:</mj-text><mj-text color="#757575" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px">Date paid:</mj-text></mj-column><mj-column width="50%"><mj-text align="right" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">$44.00</mj-text><mj-text align="right" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px">Visa*6500</mj-text><mj-text align="right" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-right="0px" padding-bottom="0px" padding-left="0px">10/5/23</mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px"><mj-column><mj-spacer height="0px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#FFFFFF" border-radius="20px"><mj-column width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/2hnfjbdd_original.jpg" alt="hers app" width="340px" href="#" border-radius="20px 0 0 20px"></mj-image></mj-column><mj-column vertical-align="middle" padding-top="40px" padding-right="30px" padding-bottom="40px" padding-left="30px" width="50%"><mj-text font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="26px" line-height="1.3" letter-spacing="-0.5px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" font-weight="400">A world of wellness</mj-text><mj-text font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px">Get ahead of your health goals with free programs and content, right from the app.</mj-text><mj-button align="left" background-color="#000000" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="17px" font-weight="600" line-height="50px" inner-padding="0px 30px 0px 30px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#" width="100%" height="50px">Get the app</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="50px" padding-bottom="0px" background-color="#F5F5F5"><mj-column><mj-text align="center" color="#1F1F1F" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="19px" padding-left="0px" font-weight="600">Healthcare that feels like self-care</mj-text><mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="48px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.facebook.com/wearehers" alt="Facebook" icon-size="48px" icon-height="48px" background-color="#F5F5F5" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/85nnldry_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://twitter.com/wearehers" alt="Twitter" icon-size="48px" icon-height="48px" background-color="#F5F5F5" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/c103084l_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.instagram.com/hers/" alt="Instagram" icon-size="48px" icon-height="48px" background-color="#F5F5F5" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/6vekzw96_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.tiktok.com/@hers" alt="TikTok" icon-size="48px" icon-height="48px" background-color="#F5F5F5" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/uupj8vs4_original.png"></mj-social-element></mj-social></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="40px" background-color="#F5F5F5"><mj-column><mj-text align="center" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="12px" line-height="15px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px">© 2026 Hims, Inc.<br />2269 Chestnut Street #523 | San Francisco | CA 94123</mj-text><mj-text align="center" font-family="'SofiaPro', 'Helvetica Neue', Helvetica, Arial, sans-serif" font-size="12px" line-height="15px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="https://www.forhers.com/privacy-policy">Privacy Policy</a></span> |&nbsp;<span><a href="https://www.forhers.com/terms-and-conditions">Terms of Service</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template45",
    title: "Template 45",
    thumbnail: thumb45,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
    <mj-font name="SofiaPro" href="https://fonts.googleapis.com/css2?family=Sofia+Sans:wght@300;400;500;700&display=swap" />
  </mj-head>
  <mj-body width="700px" background-color="#FFFFFF" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" background-color="#FFFFFF"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/su38m42y_original.png" alt="hims" width="80px" href="https://links.news.hims.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="40px" padding-right="60px" padding-bottom="0px" padding-left="60px" background-color="#F7F7F7" border-radius="20px 20px 0 0"><mj-column><mj-text align="center" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="57px" line-height="1.05" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="400">Custom care to&nbsp;<span style="color:#d58b6b;">fit</span>&nbsp;<span style="color:#cc8166;">every</span>&nbsp;<span style="color:#a04751;">goal</span></mj-text><mj-text align="center" color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="24px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px">Your health history and goals are totally unique—so your care should be too. Discover treatments designed with you in mind.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="60px" padding-bottom="16px" padding-left="60px" background-color="#F7F7F7"><mj-column width="55%"><mj-button background-color="#000000" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="16px" font-weight="400" line-height="20px" inner-padding="14px 28px 14px 28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://links.news.hims.com">Explore all treatments</mj-button></mj-column><mj-column width="45%"><mj-button background-color="#FFFFFF" border="1px solid #AAAAAA" border-radius="100px" color="#000000" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="16px" font-weight="400" line-height="20px" inner-padding="14px 28px 14px 28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://links.news.hims.com">Learn more</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px" background-color="#F7F7F7"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="60px" padding-bottom="0px" padding-left="60px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/orf3asrh_original.jpg" alt="Hims products" width="580px"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="48px" padding-right="60px" padding-bottom="0px" padding-left="60px" background-color="#F7F7F7"><mj-column width="55%"><mj-text font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="29px" line-height="1.15" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="400">A range of weight loss medications</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Compounded GLP-1 injections starting at $149/mo</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Support from providers and ongoing check-ins</mj-text><mj-button align="left" background-color="#000000" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="17px" font-weight="400" line-height="20px" inner-padding="12px 24px 12px 24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://links.news.hims.com">Check it out</mj-button></mj-column><mj-column width="45%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/2lt79jj1_original.jpg" alt="Weight Loss Medications" width="270px" href="https://links.news.hims.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="48px" padding-right="60px" padding-bottom="0px" padding-left="60px" background-color="#F7F7F7"><mj-column width="55%"><mj-text font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="29px" line-height="1.15" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="400">Hair Hybrids</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Regrow hair in 3-6 months or your money back</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Support overall hair health and thickness</mj-text><mj-button align="left" background-color="#000000" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="17px" font-weight="400" line-height="20px" inner-padding="12px 24px 12px 24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://links.news.hims.com">Check it out</mj-button></mj-column><mj-column width="45%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/p509vyzw_original.jpg" alt="Hair Hybrids" width="270px" href="https://links.news.hims.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="48px" padding-right="60px" padding-bottom="0px" padding-left="60px" background-color="#F7F7F7" border-radius="0 0 20px 20px"><mj-column width="55%"><mj-text font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="29px" line-height="1.15" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="400">Sex Rx + Multivitamin</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Be ready for sex anytime, anywhere</mj-text><mj-text color="#565656" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px"><img src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fluw48b2_original.png" width="20" height="20" style="vertical-align:middle;margin-right:8px;" />Support energy, muscle function, and more</mj-text><mj-button align="left" background-color="#000000" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="17px" font-weight="400" line-height="20px" inner-padding="12px 24px 12px 24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://links.news.hims.com">Check it out</mj-button></mj-column><mj-column width="45%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/zrf1r3i0_original.jpg" alt="Sex Rx + Multivitamin" width="270px" href="https://links.news.hims.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="35px" padding-right="60px" padding-bottom="24px" padding-left="60px" background-color="#F7F7F7"><mj-column><mj-text align="center" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="32px" line-height="1.15" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="400">Take charge of your health with care that puts&nbsp;<span style="color:#bf775d;">you</span>&nbsp;<span style="color:#ac5e54;">first</span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="30px" padding-right="30px" padding-bottom="16px" padding-left="30px" background-color="#000000"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="12px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px">Compounded drug products are not FDA-approved. FDA does not evaluate compounded drugs for safety, effectiveness, or quality. Prescription products require an online consultation with a healthcare provider who will determine if a prescription is appropriate. See website for full details, important safety information, and restrictions.</mj-text><mj-text align="center" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="24px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px" font-weight="500">Future you thanks you.</mj-text><mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="48px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://links.news.hims.com" alt="Facebook" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/iv19gvgn_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://links.news.hims.com" alt="Twitter" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/nkbu47o4_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://links.news.hims.com" alt="Instagram" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/ylx8r55s_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://links.news.hims.com" alt="TikTok" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5as4xrak_original.png"></mj-social-element></mj-social><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">© 2025 Hims, Inc.</mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">2269 Chestnut Street #523 | San Francisco | CA 94123</mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">Hims:&nbsp;<span><a href="#">privacy policy</a></span> |&nbsp;<span><a href="#">terms of service</a></span></mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px"><span><a href="{{unsubscribeUrl}}">unsubscribe</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template46",
    title: "Template 46",
    thumbnail: thumb46,
    mjml: `<mjml>
  <mj-head>
    <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
    <mj-font name="SofiaPro" href="https://fonts.googleapis.com/css2?family=Sofia+Sans:wght@300;400;500;600;700&display=swap" />
  </mj-head>
  <mj-body width="700px" background-color="#FAF8F2" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="16px" padding-bottom="16px" background-color="#FAF8F2"><mj-group><mj-column vertical-align="middle" width="43%"><mj-spacer height="1px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column><mj-column vertical-align="middle" width="14%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/ugys1d9t_original.png" alt="hims" width="80px" href="https://www.forhims.com"></mj-image></mj-column><mj-column vertical-align="middle" width="43%"><mj-button align="right" background-color="#FFFFFF" border="1px solid #AAAAAA" border-radius="20px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="15px" font-weight="500" letter-spacing="1px" line-height="35px" inner-padding="0px 20px 0px 20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.forhims.com/consultation/ed">LOGIN</mj-button></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" background-size="75% auto" background-position="130% 100%" padding="20px 0" padding-top="30px" padding-right="30px" padding-bottom="30px" padding-left="30px" background-color="#E7F4FD" background-url="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/cgtx9o1a_original.png" border-radius="30px"><mj-column width="65%"><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="45px" line-height="1.12" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="15px" padding-left="0px" font-weight="600">Play things</mj-text><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="19px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="15px" padding-left="0px">Variety is the spice of life, including your sex life. That's why we offer a range of products to help you get more out of your love life.</mj-text><mj-button align="left" background-color="#000001" border="1px solid #AAAAAA" border-radius="100px" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" font-weight="400" line-height="50px" inner-padding="0px 30px 0px 30px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.forhims.com/consultation/ed">Get started</mj-button></mj-column><mj-column width="35%"><mj-spacer height="1px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px" background-color="#FAF8F2"><mj-column padding-right="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5nta5hnw_original.png" alt="Delay Spray" width="332px" href="https://www.forhims.com/premature-ejaculation/delay-spray"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="20px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">Delay Spray</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">This spray can help you keep going (and going and going).</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/premature-ejaculation/delay-spray" width="100%">Shop now</mj-button></mj-column><mj-column padding-left="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/aqe614x6_original.png" alt="OMG Ring Vibrator" width="332px" href="https://www.forhims.com/sexual-health/male-vibrator"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="20px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">OMG Ring Vibrator</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Hands-free, remote-controlled fun everyone can get behind</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/sexual-health/male-vibrator" width="100%">Shop now</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="0px" background-color="#FAF8F2"><mj-column padding-right="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/e0zajcc3_original.png" alt="Ultra Thin Condoms" width="332px" href="https://www.forhims.com/sexual-health/ultra-thin-condoms"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="20px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">Ultra Thin Condoms</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">These natural latex condoms are ultra thin to maximize sensitivity.</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/sexual-health/ultra-thin-condoms" width="100%">Shop now</mj-button></mj-column><mj-column padding-left="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/dsvxkoq8_original.png" alt="Glide Water-Based Lube" width="332px" href="https://www.forhims.com/sexual-health/water-based-lube"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="20px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">Glide Water-Based Lube</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Let things slide with our water- and aloe-based lubricant</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/sexual-health/water-based-lube" width="100%">Shop now</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-bottom="40px" background-color="#FAF8F2"><mj-column padding-right="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/w57ppx2t_original.png" alt="Premature Ejaculation Prescription" width="332px" href="https://www.forhims.com/premature-ejaculation/sertraline-for-pe"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="19px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">Premature Ejaculation Prescription</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Shown to help guys last up to 12 times&nbsp;</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/premature-ejaculation/sertraline-for-pe" width="100%">Get started</mj-button></mj-column><mj-column padding-left="10px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9lo7w90s_original.png" alt="Erectile Dysfunction Prescription" width="332px" href="https://www.forhims.com/consultation/ed"></mj-image><mj-text font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="19px" line-height="1.25" padding="10px 25px" padding-right="0px" padding-bottom="5px" padding-left="0px" font-weight="600">Erectile Dysfunction Prescription</mj-text><mj-text color="#000001" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="17px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">A boost to get hard and stay hard</mj-text><mj-button align="left" background-color="#FBF8F5" border="1px solid #AAAAAA" border-radius="0px" color="#000000" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="16px" font-weight="400" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://www.forhims.com/consultation/ed" width="100%">Get started</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="45px" padding-right="40px" padding-left="40px" background-color="#000000"><mj-column><mj-text align="center" color="#FFFFFF" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px" font-weight="500">handsome, healthy you. #hellohims</mj-text><mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="48px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.facebook.com/wearehims" alt="Facebook" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jrr9y9md_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://twitter.com/wearehims" alt="Twitter" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/uzyoxhez_original.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://www.instagram.com/hims/" alt="Instagram" icon-size="48px" icon-height="48px" background-color="#000000" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/b6mhwa8b_original.png"></mj-social-element></mj-social><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">© 2022 Hims, Inc.</mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">2269 Chestnut Street #523 | San Francisco | CA 94123</mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px"><span><a href="#">privacy policy</a></span> |&nbsp;<span><a href="#">terms of service</a></span></mj-text><mj-text align="center" color="#9D9D9D" font-family="'Sofia Sans', SofiaPro, Helvetica, Arial, sans-serif" font-size="10px" line-height="12px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px"><span><a href="{{unsubscribeUrl}}">unsubscribe</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template47",
    title: "Template 47",
    thumbnail: thumb47,
    mjml: `<mjml>
  <mj-head>
      <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="420px" background-color="#F0F2F5" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="40px" padding-bottom="40px" background-color="#F0F2F5"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/9u0vo9vc_80x80.png" alt="Fast" width="48px" href="#"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="28px" padding-right="24px" padding-bottom="0px" padding-left="24px" background-color="#FFFFFF" border-radius="6px 6px 0 0"><mj-column><mj-text font-family="Inter, Helvetica, Arial, sans-serif" font-size="16px" line-height="160%" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="400">Transaction #6500500</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="28px" padding-right="24px" padding-bottom="28px" padding-left="24px" background-color="#FFFFFF"><mj-column><mj-text font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700">Hi Smiles Davis,</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="24px" padding-bottom="29px" padding-left="24px" background-color="#FFFFFF" border-radius="0 0 6px 6px"><mj-column><mj-text font-family="Inter, Helvetica, Arial, sans-serif" font-size="16px" line-height="160%" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px">Great news! Your&nbsp;<b>Prima Coffee</b> order&nbsp;<b>has shipped</b> and is currently making its way to you.</mj-text><mj-text color="#F0F2F5" font-family="Helvetica, Arial, sans-serif" font-size="1px" line-height="1px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">
          <div style="width:100%;height:10px;border-radius:4px;background:#E8E8E8;">
            <div style="width:50%;height:10px;border-radius:4px;background:#0C845C;">&nbsp;</div>
          </div>
        </mj-text><mj-text color="#0C845C" font-family="Inter, Helvetica, Arial, sans-serif" font-size="14px" line-height="16px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="18px" padding-left="0px" font-weight="700">Shipped</mj-text><mj-button background-color="#000000" border-radius="8px" color="#FFFFFF" font-family="Helvetica, Arial, sans-serif" font-size="14px" font-weight="700" line-height="40px" inner-padding="0px 0px 0px 0px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#" width="100%">Track your order on Fast.co</mj-button><mj-text align="center" color="#474747" font-family="Inter, Helvetica, Arial, sans-serif" font-size="12px" line-height="150%" padding="10px 25px" padding-top="24px" padding-right="0px" padding-bottom="0px" padding-left="0px">We'll update your dashboard when the order is out for delivery</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="24px" padding-bottom="0px"><mj-column><mj-spacer height="0px" padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px"></mj-spacer></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="27px" padding-right="24px" padding-bottom="0px" padding-left="24px" background-color="#FFFFFF" border-radius="6px"><mj-column><mj-text font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">Your Order</mj-text><mj-text color="#474747" font-family="Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-right="0px" padding-left="0px">Order ID:: 650055</mj-text><mj-divider border-width="2px" border-color="#F0F2F5" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="16px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="24px" padding-bottom="0px" padding-left="24px" background-color="#FFFFFF"><mj-column width="64px"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/zrf1r3i0_original.jpg" alt="What I Know About Running Coffee Shops Book" width="64px" border-radius="4px" fluid-on-mobile="true"></mj-image></mj-column><mj-column padding-left="17px"><mj-text font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">What I Know About Running Coffee Shops Book</mj-text><mj-text color="#808080" font-family="Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-top="3px" padding-right="0px" padding-bottom="0px" padding-left="0px">Qty: 1</mj-text></mj-column><mj-column width="80px"><mj-text align="right" font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">$40.00</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="24px" padding-bottom="0px" padding-left="24px" background-color="#FFFFFF"><mj-column><mj-divider border-width="2px" border-color="#F0F2F5" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="16px" padding-left="0px"></mj-divider><mj-text font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">
          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">
            <tbody>
              <tr>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;">Subtotal</td>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;text-align:right;">$40.00</td>
              </tr>
              <tr>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;">Tax</td>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;text-align:right;">$0.00</td>
              </tr>
              <tr>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;">Shipping</td>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0 0 0;text-align:right;">$8.60</td>
              </tr>
              <tr>
                <td style="font:bold 16px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0;">Total (USD)</td>
                <td style="font:bold 16px Helvetica,Arial,sans-serif;color:#000000;padding:16px 0;text-align:right;">$48.60</td>
              </tr>
            </tbody>
          </table>
        </mj-text><mj-divider border-width="2px" border-color="#F0F2F5" padding="10px 25px" padding-top="16px" padding-right="0px" padding-bottom="32px" padding-left="0px"></mj-divider><mj-text font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">
          <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">
            <tbody>
              <tr>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:0 0 24px 0;">amex 6500</td>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:0 0 24px 0;text-align:right;">January 14, 2022</td>
              </tr>
              <tr>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:0 0 24px 0;vertical-align:top;">Smiles Davis</td>
                <td style="font:14px Helvetica,Arial,sans-serif;color:#000000;padding:0 0 24px 0;text-align:right;line-height:200%;">600 Montgomery St<br />San Francisco, CA 94111</td>
              </tr>
            </tbody>
          </table>
        </mj-text><mj-text align="center" color="#474747" font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="16px" padding-bottom="24px" padding-left="16px">Questions about your order? Please contact&nbsp;<b style="color:#000000;">Prima Coffee</b> or visit&nbsp;<span><a href="https://prima-coffee.com">https://prima-coffee.com</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="8px" padding-bottom="40px" background-color="#F0F2F5"><mj-column><mj-text align="center" color="#808080" font-family="Helvetica, Arial, sans-serif" font-size="12px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">2021 Fast<br /><br />349 9th Street<br />San Francisco, CA 94103<br /><br /><span><a href="#">Contact Us</a></span>   <span><a href="#">Privacy Policy</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template48",
    title: "Template 48",
    thumbnail: thumb48,
    mjml: `<mjml>
  <mj-head>
       <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="580px" background-color="#F3F3F3" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="48px" padding-right="16px" padding-bottom="16px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jg6ekntx_logo_standard_2x-c0ed1450d18490825bc37dd6cb23e5c5.png" alt="Airbnb" width="100px" href="https://www.airbnb.com"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="32px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Your reservation is confirmed</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="300">You're going to San Francisco.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="8px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fglfwqm9_3a4e6241-7bd2-47e0-8f67-5c3c6e21d20a.jpg" alt="Listing Photo" width="548px" href="https://www.airbnb.com/"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column vertical-align="middle"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">Superhosted Castro Studio. Easy Parking. No Keys.</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Entire home/apt hosted by Christian</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-group><mj-column width="42%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Tuesday,</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">Oct 24, 2017</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Check in Anytime after 3PM</mj-text></mj-column><mj-column vertical-align="middle" width="16%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/h37acic6_slash-7e6cd0c69def410f055ffd703c08e140.png" width="40px"></mj-image></mj-column><mj-column width="42%"><mj-text align="right" color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Friday,</mj-text><mj-text align="right" color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">OCT 27, 2017</mj-text><mj-text align="right" color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Check out 11AM</mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-button background-color="#FF5A5F" border-radius="4px" color="#FFFFFF" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" font-weight="400" line-height="32px" inner-padding="19px 24px 19px 24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.airbnb.com" width="100%">View Full Itinerary</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column width="60%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">Address</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">650 Street, San Francisco, CA 94114, United States</mj-text></mj-column><mj-column width="40%"><mj-text align="right" color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300"><span><a href="https://www.airbnb.com">Get Directions</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">Guests</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">1</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column width="60%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">Amount</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">$650.65</mj-text></mj-column><mj-column width="40%"><mj-text align="right" color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300"><span><a href="https://www.airbnb.com">View Receipt</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column width="60%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">Reservation Code</mj-text></mj-column><mj-column width="40%"><mj-text align="right" color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">SMLSDVS</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-button background-color="#FEFEFE" border="1px solid #AAAAAA" border-radius="4px" color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" font-weight="400" line-height="32px" inner-padding="19px 24px 19px 24px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://www.airbnb.com" width="100%">Change Your Reservation</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column width="85%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Christian is your host</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="300">Contact Christian to coordinate arrival time and key exchange.</mj-text><mj-text color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" font-weight="300"><span><a href="https://www.airbnb.com">Message Host</a></span> •&nbsp;<span><a href="tel:+12345678910">+1 (234) 567-8910</a></span></mj-text></mj-column><mj-column width="15%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/3woostbru3adozviwv8qk_image.png" alt="Christian" width="77px" border-radius="50%" href="https://www.airbnb.com"></mj-image><mj-image padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/idtyrh4k_5.0_stars-8b3a9b9fe0d1aa014b1f97859cd599b1.png" alt="5.0 stars" width="77px"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" width="50px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Know what to expect</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="300">Make sure to review the house rules and amenities.</mj-text><mj-text color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300"><span><a href="https://www.airbnb.com">View House Rules & Manual</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" width="50px" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-group><mj-column width="15%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/57s6q59c_dollar_sign_small-1b3b20b329165157d970e14352f53ab5.png" width="40px"></mj-image></mj-column><mj-column width="85%"><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Earn up to $95</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="300">Share your personal invite link and earn up to $95 for every friend who completes a qualifying reservation.</mj-text><mj-text color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.airbnb.com">Invite Friends</a></span></mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="32px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Find unique things to do in San Francisco</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="300">Experiences are activities led by local experts that go beyond typical tours or classes.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="32px" padding-left="16px" background-color="#FEFEFE"><mj-column padding-right="8px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jxxos4fo_e86c7a92-e541-4b6b-90e3-739e9f423d5f.jpg" alt="Food meets bike tour" width="274px" href="https://www.airbnb.com/experiences/75951"></mj-image><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="400">A food meets bike tour of SF's culinary capital</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="15px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">4-hour experience</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="15px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.airbnb.com/experiences/75951">See details ›</a></span></mj-text></mj-column><mj-column padding-left="8px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/jxxos4fo_e86c7a92-e541-4b6b-90e3-739e9f423d5f.jpg" alt="Taste sake in a brewery" width="274px" href="https://www.airbnb.com/experiences/40564"></mj-image><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.4" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="400">Taste sake in a brewery paired with pickles and chocolate</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="15px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="300">2-hour experience</mj-text><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="15px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="700"><span><a href="https://www.airbnb.com/experiences/40564">See details ›</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="1px" border-color="#CACACA" padding="10px 25px" padding-top="20px" padding-right="0px" padding-bottom="20px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-text color="#484848" font-family="Circular, Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="700">Customer support</mj-text><mj-text color="#FF5A5F" font-family="Circular, Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="https://www.airbnb.com">Visit Help Center</a></span> •&nbsp;<span><a href="https://www.airbnb.com">Contact Airbnb</a></span></mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="32px" padding-right="16px" padding-bottom="0px" padding-left="16px" background-color="#FEFEFE"><mj-column><mj-divider border-width="2px" border-color="#CACACA" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="32px" padding-left="0px"></mj-divider><mj-text color="#9CA299" font-family="Circular, Helvetica, Arial, sans-serif" font-size="14px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="300">Sent with ♥ from Airbnb</mj-text><mj-text color="#9CA299" font-family="Circular, Helvetica, Arial, sans-serif" font-size="14px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="300">Airbnb, Inc., 888 Brannan St, San Francisco, CA 94103</mj-text><mj-text color="#9CA299" font-family="Circular, Helvetica, Arial, sans-serif" font-size="14px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="32px" padding-left="0px" font-weight="300"><span><a href="https://www.airbnb.com">Earn travel credit</a></span></mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template49",
    title: "Template 49",
    thumbnail: thumb49,
    mjml: `<mjml>
  <mj-head>
      <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#FFFFFF" css-class="mjbody">
    <mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/8sz0ksu2_75d1b9dd-0aef-441d-9942-126ee09ce6ba.png" alt="The Airbnb Logo" width="600px"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="48px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/3irwl4ov_69e1604a-4d10-4d29-a68b-b6a321b8c131.png" alt="Homes for every kind of weekend" width="600px"></mj-image><mj-text align="center" color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="24px" padding-right="48px" padding-bottom="0px" padding-left="48px">Planning a quick getaway starts with one simple question: What are you in the mood for?</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="16px" padding-left="20px"><mj-group><mj-column padding-right="4px" padding-bottom="8px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/glvey2ik_62dca66a-1d0f-464e-82d5-7fe526423fb8.jpeg" alt="A row of colorful town homes under a blue sky" width="300px" border-radius="8px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Top destinations ›</a></span></mj-text></mj-column><mj-column padding-bottom="8px" padding-left="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gs4h2b46_133cdec7-f8fc-4e0d-8110-f9bb11723f05.jpeg" alt="A black lab lays out on an orange rug" width="300px" border-radius="8px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Pet-friendly homes ›</a></span></mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="40px" padding-left="20px"><mj-group><mj-column padding-right="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gymbg4tr_ea4cde8a-4366-4aa5-b6a6-5e4962cec36a.jpeg" alt="A large open room with plenty of places to sit near a fireplace" width="300px" border-radius="8px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Family getaways ›</a></span></mj-text></mj-column><mj-column padding-left="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5qp3aj07_7812d759-568b-4ad3-9089-c2a3d05f6d6d.jpeg" alt="Two lounge chairs sit on a terrace, overlooking the ocean" width="300px" border-radius="8px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Waterfront retreats ›</a></span></mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="16px" padding-left="48px"><mj-column><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="26px" line-height="30px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="32px" padding-left="0px" font-weight="500">Great homes at great prices</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="16px" padding-left="20px"><mj-group><mj-column padding-right="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5qp3aj07_7812d759-568b-4ad3-9089-c2a3d05f6d6d.jpeg" alt="Apartment in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Apartment in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.97</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">2 king beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span style="text-decoration:line-through;color:#6A6A6A;">$1,283</span> $900 for 2 nights</mj-text></mj-column><mj-column padding-left="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/wsiuwahr_bae5d7b2-0883-45d4-96ff-454bf8890059.jpeg" alt="Cottage in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Cottage in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.98</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">2 king beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span style="text-decoration:line-through;color:#6A6A6A;">$1,100</span> $770 for 2 nights</mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="96px" padding-left="20px"><mj-column><mj-button background-color="#FFFFFF" border="1px solid #AAAAAA" border-radius="8px" color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="18px" font-weight="500" line-height="1.3" inner-padding="16px 32px 16px 32px" padding="10px 25px" padding-top="24px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#">Explore homes</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="16px" padding-left="20px"><mj-column><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="26px" line-height="30px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="32px" padding-left="0px" font-weight="500">Get a nearby home other guests love</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="16px" padding-left="20px"><mj-group><mj-column padding-right="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/w6l0vrcg_6f055027-0132-44f9-a4ac-7f50cb62fb59.jpg" alt="Apartment in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Apartment in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.95</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">2 beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$350 for 2 nights</mj-text></mj-column><mj-column padding-left="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/5qp3aj07_7812d759-568b-4ad3-9089-c2a3d05f6d6d.jpeg" alt="Apartment in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Apartment in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.92</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">3 beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$420 for 2 nights</mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-bottom="16px" padding-left="20px"><mj-group><mj-column padding-right="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/glvey2ik_62dca66a-1d0f-464e-82d5-7fe526423fb8.jpeg" alt="Apartment in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Apartment in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.90</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">2 beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$280 for 2 nights</mj-text></mj-column><mj-column padding-left="4px" width="50%"><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gymbg4tr_ea4cde8a-4366-4aa5-b6a6-5e4962cec36a.jpeg" alt="Cabin in Galena" width="300px" border-radius="12px" href="#"></mj-image><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500"><span><a href="#">Cabin in Galena</a></span>&nbsp;<span style="font-weight:400;">★ 4.88</span></mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="300">4 beds<br />Jan 23 – 25</mj-text><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="16px" line-height="22px" padding="10px 25px" padding-top="4px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">$510 for 2 nights</mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="104px" padding-left="48px"><mj-column><mj-button background-color="#FFFFFF" border="1px solid #AAAAAA" border-radius="8px" color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="18px" font-weight="500" line-height="1.3" inner-padding="16px 32px 16px 32px" padding="10px 25px" padding-top="24px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#">See more homes</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="12px" padding-left="48px"><mj-column><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="26px" line-height="30px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Build your wishlist together</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="32px" padding-left="48px"><mj-column><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="28px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">As you're exploring, create a list of places that catch your eye and invite others to vote, add notes, and more.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="32px"><mj-column><mj-button background-color="#222222" border-radius="8px" color="#FFFFFF" font-family="Helvetica, Arial, sans-serif" font-size="18px" font-weight="500" line-height="1.3" inner-padding="16px 32px 16px 32px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#">Start exploring</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-bottom="0px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="96px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/l999txvu_ccf11b0a-a5dc-4906-a9ad-d2bc0eacb2cf.png" alt="A large house with a bay window, tucked into rolling hills. Guest chat bubbles vote yes on the listing." width="600px"></mj-image></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="0px" padding-left="48px"><mj-column><mj-divider border-width="1px" border-color="#DDDDDD" padding="10px 25px" padding-top="8px" padding-right="0px" padding-bottom="32px" padding-left="0px"></mj-divider></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="96px" padding-bottom="0px" padding-left="96px"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/bubkmwsq_52c01bc6-468a-4193-9213-0074aadb978b.png" alt="Airbnb" width="42px"></mj-image><mj-text align="center" color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" font-weight="500">Get the app.</mj-text><mj-text align="center" color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="18px" line-height="22px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px" font-weight="500">The fastest, easiest way to Airbnb.</mj-text></mj-column></mj-section><mj-section padding="20px 0"><mj-group><mj-column width="50%"><mj-image align="right" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/o8diuhvy_12ed8a90-f7ac-439a-99b3-cbc7aedee0a6.jpg" alt="Google Play" width="135px" href="#"></mj-image></mj-column><mj-column width="50%"><mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/ndy5qr62_0bd65cfc-ddd4-4ef1-a4e3-1d5e79b225ca.jpg" alt="App Store" width="120px" href="#"></mj-image></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="48px" padding-right="48px" padding-bottom="0px" padding-left="48px"><mj-column><mj-text align="center" color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px">Airbnb, Inc., 888 Brannan St., San Francisco, CA 94103, USA</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="48px" padding-bottom="0px" padding-left="48px"><mj-column><mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="24px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="#" alt="TikTok" icon-size="24px" icon-height="24px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/sgvhb1dd_e7400c06-00e9-459b-9829-1cc0d4c0326b.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="#" alt="Instagram" icon-size="24px" icon-height="24px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/8iow5n9c_d98da6f9-52e5-47f8-9f15-134acfbf5e4b.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="#" alt="Twitter" icon-size="24px" icon-height="24px" background-color="#FFFFFF" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/t4fevcyd_126739e6-d2c8-47eb-82d5-c26299302f2f.png"></mj-social-element></mj-social><mj-divider border-width="1px" border-color="#DDDDDD" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px"></mj-divider><mj-text color="#222222" font-family="Helvetica, Arial, sans-serif" font-size="14px" line-height="20px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="24px" padding-left="0px"><span><a href="#">Update your email preferences</a></span> to choose which emails you get or&nbsp;<span><a href="{{unsubscribeUrl}}">unsubscribe</a></span> from this type of email.</mj-text><mj-text color="#6A6A6A" font-family="Helvetica, Arial, sans-serif" font-size="12px" line-height="16px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="32px" padding-left="0px">Prices accurate at time of send.</mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
  {
    id: "template50",
    title: "Template 50",
    thumbnail: thumb50,
    mjml: `<mjml>
  <mj-head>
      <mj-style>.mjbody a, .mjbody a:hover, .mjbody a:active, .mjbody a[href], .mjbody a[href]:hover, .mjbody a[href]:active {color: inherit;text-decoration: underline}</mj-style>
    <mj-breakpoint width="480px" />
  </mj-head>
  <mj-body width="600px" background-color="#F5F5F7" css-class="mjbody">
    <mj-section background-repeat="no-repeat" background-size="cover" background-position="center center" padding="20px 0" padding-top="30px" padding-right="20px" padding-bottom="10px" padding-left="20px" background-color="#1C1C1C" background-url="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/4cntxqp0_f5adc1ca-a1cc-4dd8-acaf-0804eda09568.gif"><mj-column><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/eghw14nx_bc7e6153-71a3-4e25-baa2-2fa45ae89c55.png" alt="SHIFT" width="230px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_0"></mj-image><mj-text align="center" color="#FFFFFF" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px">Welcome to the future of walking.</mj-text><mj-text align="center" color="#FFFFFF" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="60px" line-height="1.1" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="8px" padding-left="0px" font-weight="400">Take the next step with&nbsp;<span style="color:#D2F944;">15% off.</span></mj-text><mj-text align="center" color="#FFFFFF" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px">Offer applies automatically.</mj-text><mj-text align="center" color="#FFFFFF" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="12px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="16px" padding-left="0px">Cannot be combined with any other promotions.</mj-text><mj-button background-color="#D2F944" border-radius="50px" color="#000000" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="17px" font-weight="400" line-height="1" inner-padding="15px 25px 15px 25px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_1">Shop Now</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="30px" padding-right="20px" padding-bottom="0px" padding-left="20px" background-color="#EFEFEF"><mj-column><mj-text align="center" color="#121212" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="40px" line-height="1.1" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="20px" padding-left="0px" font-weight="400">Your journey begins here.</mj-text></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="10px" padding-bottom="30px" padding-left="10px" background-color="#EFEFEF"><mj-column padding-right="10px" padding-left="10px" width="50%"><mj-text color="#121212" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="400">Moonwalkers Aero</mj-text><mj-text color="#6B6B6B" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px">Lighter, quieter, and great for urban environments.</mj-text><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/02sb8zrc_2a81f6a1-2499-4af6-960c-79b43cff3892.png" alt="Moonwalkers Aero" width="300px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_2"></mj-image><mj-text font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px">★★★★★</mj-text><mj-text color="#121212" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="2px" padding-left="0px">"Great product. It feels like gliding."</mj-text><mj-text color="#6B6B6B" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px">Nikolaus O.</mj-text><mj-button align="left" background-color="#D2F944" border-radius="50px" color="#000000" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="17px" font-weight="400" line-height="1" inner-padding="15px 35px 15px 35px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_3">Explore</mj-button></mj-column><mj-column padding-right="10px" padding-left="10px" width="50%"><mj-text color="#121212" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="24px" line-height="1.2" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px" font-weight="400">Moonwalkers</mj-text><mj-text color="#6B6B6B" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px">Built rugged to handle cracks and uneven terrain.</mj-text><mj-image padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/zrvlj7kz_c6d7afa7-e0d9-45eb-b2e2-e50fa2973bf0.png" alt="Moonwalkers" width="300px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_4"></mj-image><mj-text font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px">★★★★★</mj-text><mj-text color="#121212" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="18px" line-height="1.3" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="2px" padding-left="0px">"You literally just walk and off you go!!!"</mj-text><mj-text color="#6B6B6B" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.4" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="12px" padding-left="0px">Pamela G.</mj-text><mj-button align="left" background-color="#D2F944" border-radius="50px" color="#000000" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="17px" font-weight="400" line-height="1" inner-padding="15px 35px 15px 35px" padding="10px 25px" padding-top="0px" padding-right="0px" padding-left="0px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_5">Explore</mj-button></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" background-color="#1C1C1C"><mj-column><mj-social border-radius="0px" font-family="Arial, sans-serif" font-size="0px" icon-size="25px" mode="horizontal" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_6" alt="Facebook" icon-size="25px" icon-height="25px" background-color="#1C1C1C" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/z0mblwtg_d01b0e6f-04c7-4b49-ad44-635bc9ef60e0.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_7" alt="Instagram" icon-size="25px" icon-height="25px" background-color="#1C1C1C" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/fsb8dsvr_a8748eea-07ee-4a9a-bf22-f11fe4cbd92f.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_8" alt="Youtube" icon-size="25px" icon-height="25px" background-color="#1C1C1C" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/c0w8jrcz_9f829475-5044-47df-85b8-0d802857421b.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_9" alt="TikTok" icon-size="25px" icon-height="25px" background-color="#1C1C1C" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/gmbd9hqa_7cd67d02-9e2e-45a7-b584-b8707a6e6e5e.png"></mj-social-element><mj-social-element font-family="Arial, sans-serif" font-size="0px" padding="4px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="8px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_10" alt="X" icon-size="25px" icon-height="25px" background-color="#1C1C1C" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/d4j4hh66_b05760f3-2f86-4be7-9e65-b1ee2f0e0672.png"></mj-social-element></mj-social></mj-column></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="0px" padding-right="20px" padding-left="20px" background-color="#1C1C1C"><mj-group><mj-column width="50%"><mj-image align="left" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px" src="https://cdn.shopify.com/s/files/1/0863/8971/9346/files/xtrg05r6_63bdc5b2-0376-4d08-bb99-7209bc01773f.png" alt="SHIFT" width="200px" href="https://ctrk.klclick1.com/l/01KC54A1DF4YE75W3ZWCQBQ7M9_11"></mj-image></mj-column><mj-column width="50%"><mj-text align="right" color="#ABABAB" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.6" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="4px" padding-left="0px">Support</mj-text><mj-text align="right" color="#FFFFFF" font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="16px" line-height="1.6" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px"><span><a href="#">FAQs</a></span><br /><span><a href="#">Safety Information</a></span><br /><span><a href="#">Shipping & Returns</a></span><br /><span><a href="#">Contact Us</a></span></mj-text></mj-column></mj-group></mj-section><mj-section background-repeat="no-repeat" padding="20px 0" padding-top="24px" padding-right="10px" padding-bottom="24px" padding-left="10px" background-color="#F5F5F7"><mj-column><mj-text font-family="'TTHovesProRegular', Helvetica, Arial, sans-serif" font-size="14px" line-height="1.5" padding="10px 25px" padding-top="0px" padding-right="0px" padding-bottom="0px" padding-left="0px">© 2025 SHIFT ROBOTICS, INC.<br />1826 Kramer Ln Austin, Texas 78758<br />No longer want to receive these emails?&nbsp;<span><a href="{{unsubscribeUrl}}">Unsubscribe</a></span>.</mj-text></mj-column></mj-section>
  </mj-body>
</mjml>`,
  },
];
